"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});
var e,
  t = require("uuid"),
  r = require("json-schema"),
  i = (e = require("murmurhash")) && "object" == typeof e && "default" in e ? e.default : e,
  n = require("ua-parser-js"),
  _o = function o(e, t) {
    return (_o = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var r in t) Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
    })(e, t);
  };
function s(e, t) {
  if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  function r() {
    this.constructor = e;
  }
  _o(e, t), e.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r());
}
var _a = function a() {
  return (_a = Object.assign || function (e) {
    for (var t, r = 1, i = arguments.length; r < i; r++) for (var n in t = arguments[r]) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    return e;
  }).apply(this, arguments);
};
function u(e, t, r, i) {
  return new (r || (r = Promise))(function (n, o) {
    function s(e) {
      try {
        u(i.next(e));
      } catch (e) {
        o(e);
      }
    }
    function a(e) {
      try {
        u(i.throw(e));
      } catch (e) {
        o(e);
      }
    }
    function u(e) {
      var t;
      e.done ? n(e.value) : (t = e.value, t instanceof r ? t : new r(function (e) {
        e(t);
      })).then(s, a);
    }
    u((i = i.apply(e, t || [])).next());
  });
}
function l(e, t) {
  var r,
    i,
    n,
    o,
    s = {
      label: 0,
      sent: function sent() {
        if (1 & n[0]) throw n[1];
        return n[1];
      },
      trys: [],
      ops: []
    };
  return o = {
    next: a(0),
    throw: a(1),
    return: a(2)
  }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
    return this;
  }), o;
  function a(a) {
    return function (u) {
      return function (a) {
        if (r) throw new TypeError("Generator is already executing.");
        for (; o && (o = 0, a[0] && (s = 0)), s;) try {
          if (r = 1, i && (n = 2 & a[0] ? i.return : a[0] ? i.throw || ((n = i.return) && n.call(i), 0) : i.next) && !(n = n.call(i, a[1])).done) return n;
          switch (i = 0, n && (a = [2 & a[0], n.value]), a[0]) {
            case 0:
            case 1:
              n = a;
              break;
            case 4:
              return s.label++, {
                value: a[1],
                done: !1
              };
            case 5:
              s.label++, i = a[1], a = [0];
              continue;
            case 7:
              a = s.ops.pop(), s.trys.pop();
              continue;
            default:
              if (!(n = s.trys, (n = n.length > 0 && n[n.length - 1]) || 6 !== a[0] && 2 !== a[0])) {
                s = 0;
                continue;
              }
              if (3 === a[0] && (!n || a[1] > n[0] && a[1] < n[3])) {
                s.label = a[1];
                break;
              }
              if (6 === a[0] && s.label < n[1]) {
                s.label = n[1], n = a;
                break;
              }
              if (n && s.label < n[2]) {
                s.label = n[2], s.ops.push(a);
                break;
              }
              n[2] && s.ops.pop(), s.trys.pop();
              continue;
          }
          a = t.call(e, s);
        } catch (e) {
          a = [6, e], i = 0;
        } finally {
          r = n = 0;
        }
        if (5 & a[0]) throw a[1];
        return {
          value: a[0] ? a[1] : void 0,
          done: !0
        };
      }([a, u]);
    };
  }
}
function c(e, t, r) {
  if (r || 2 === arguments.length) for (var i, n = 0, o = t.length; n < o; n++) !i && n in t || (i || (i = Array.prototype.slice.call(t, 0, n)), i[n] = t[n]);
  return e.concat(i || Array.prototype.slice.call(t));
}
"function" == typeof SuppressedError && SuppressedError;
var p = new (function () {
  function e() {}
  return e.prototype.handleError = function (e) {}, e;
}())();
function d() {
  return p;
}
var f = Math.pow(2, 53);
function g(e) {
  for (var t = [], r = 1; r < arguments.length; r++) t[r - 1] = arguments[r];
  if (!e) return {};
  if ("function" == typeof Object.assign) return Object.assign.apply(Object, c([e], t, !1));
  for (var i = Object(e), n = 0; n < t.length; n++) {
    var o = t[n];
    if (null != o) for (var s in o) Object.prototype.hasOwnProperty.call(o, s) && (i[s] = o[s]);
  }
  return i;
}
function E(e, t) {
  return e ? R(e, function (e) {
    return e[t];
  }) : {};
}
function h() {
  return t.v4();
}
function I() {
  return new Date().getTime();
}
function _(e, t) {
  for (var r = !1, i = Object.keys(e), n = 0; n < i.length; n++) if (t === e[i[n]]) {
    r = !0;
    break;
  }
  return r;
}
function v(e) {
  return Object.keys(e).map(function (t) {
    return e[t];
  });
}
function y(e) {
  return Object.keys(e).map(function (t) {
    return [t, e[t]];
  });
}
function O(e, t) {
  for (var r, i = 0, n = e; i < n.length; i++) {
    var o = n[i];
    if (t(o)) {
      r = o;
      break;
    }
  }
  return r;
}
function R(e, t) {
  var r = {};
  return e.forEach(function (e) {
    var i = t(e);
    r[i] = e;
  }), r;
}
function N(e) {
  for (var t = [], r = 1; r < arguments.length; r++) t[r - 1] = arguments[r];
  var i = 0;
  return e.replace(/%s/g, function () {
    var e = t[i++],
      r = typeof e;
    return "function" === r ? e() : "string" === r ? e : String(e);
  });
}
function T(e, t) {
  return e.length === t.length && e.every(function (e, r) {
    return e === t[r];
  });
}
var m,
  A = {
    assign: g,
    checkArrayEquality: T,
    currentTimestamp: function currentTimestamp() {
      return Math.round(new Date().getTime());
    },
    isSafeInteger: function isSafeInteger(e) {
      return "number" == typeof e && Math.abs(e) <= f;
    },
    keyBy: E,
    uuid: h,
    isNumber: function isNumber(e) {
      return "number" == typeof e;
    },
    getTimestamp: I,
    isValidEnum: _,
    groupBy: function groupBy(e, t) {
      var r = {};
      return e.forEach(function (e) {
        var i = t(e);
        r[i] = r[i] || [], r[i].push(e);
      }), v(r);
    },
    objectValues: v,
    objectEntries: y,
    find: O,
    keyByUtil: R,
    sprintf: N
  };
(m = exports.LogLevel || (exports.LogLevel = {}))[m.NOTSET = 0] = "NOTSET", m[m.DEBUG = 1] = "DEBUG", m[m.INFO = 2] = "INFO", m[m.WARNING = 3] = "WARNING", m[m.ERROR = 4] = "ERROR";
var D = {
  NOTSET: 0,
  DEBUG: 1,
  INFO: 2,
  WARNING: 3,
  ERROR: 4
};
function S(e) {
  return "string" != typeof e ? e : ("WARN" === (e = e.toUpperCase()) && (e = "WARNING"), D[e] ? D[e] : e);
}
var L = function () {
    function e() {
      this.defaultLoggerFacade = new b(), this.loggers = {};
    }
    return e.prototype.getLogger = function (e) {
      return e ? (this.loggers[e] || (this.loggers[e] = new b({
        messagePrefix: e
      })), this.loggers[e]) : this.defaultLoggerFacade;
    }, e;
  }(),
  U = function () {
    function e(e) {
      void 0 === e && (e = {}), this.logLevel = exports.LogLevel.NOTSET, void 0 !== e.logLevel && _(exports.LogLevel, e.logLevel) && this.setLogLevel(e.logLevel), this.logToConsole = void 0 === e.logToConsole || !!e.logToConsole, this.prefix = void 0 !== e.prefix ? e.prefix : "[OPTIMIZELY]";
    }
    return e.prototype.log = function (e, t) {
      if (this.shouldLog(e) && this.logToConsole) {
        var r = "".concat(this.prefix, " - ").concat(this.getLogLevelName(e), " ").concat(this.getTime(), " ").concat(t);
        this.consoleLog(e, [r]);
      }
    }, e.prototype.setLogLevel = function (e) {
      e = S(e), _(exports.LogLevel, e) && void 0 !== e ? this.logLevel = e : this.logLevel = exports.LogLevel.ERROR;
    }, e.prototype.getTime = function () {
      return new Date().toISOString();
    }, e.prototype.shouldLog = function (e) {
      return e >= this.logLevel;
    }, e.prototype.getLogLevelName = function (e) {
      switch (e) {
        case exports.LogLevel.DEBUG:
          return "DEBUG";
        case exports.LogLevel.INFO:
          return "INFO ";
        case exports.LogLevel.WARNING:
          return "WARN ";
        case exports.LogLevel.ERROR:
          return "ERROR";
        default:
          return "NOTSET";
      }
    }, e.prototype.consoleLog = function (e, t) {
      switch (e) {
        case exports.LogLevel.DEBUG:
          console.log.apply(console, t);
          break;
        case exports.LogLevel.INFO:
          console.info.apply(console, t);
          break;
        case exports.LogLevel.WARNING:
          console.warn.apply(console, t);
          break;
        case exports.LogLevel.ERROR:
          console.error.apply(console, t);
          break;
        default:
          console.log.apply(console, t);
      }
    }, e;
  }(),
  C = exports.LogLevel.NOTSET,
  P = null,
  b = function () {
    function e(e) {
      void 0 === e && (e = {}), this.messagePrefix = "", e.messagePrefix && (this.messagePrefix = e.messagePrefix);
    }
    return e.prototype.log = function (e, t) {
      for (var r = [], i = 2; i < arguments.length; i++) r[i - 2] = arguments[i];
      this.internalLog(S(e), {
        message: t,
        splat: r
      });
    }, e.prototype.info = function (e) {
      for (var t = [], r = 1; r < arguments.length; r++) t[r - 1] = arguments[r];
      this.namedLog(exports.LogLevel.INFO, e, t);
    }, e.prototype.debug = function (e) {
      for (var t = [], r = 1; r < arguments.length; r++) t[r - 1] = arguments[r];
      this.namedLog(exports.LogLevel.DEBUG, e, t);
    }, e.prototype.warn = function (e) {
      for (var t = [], r = 1; r < arguments.length; r++) t[r - 1] = arguments[r];
      this.namedLog(exports.LogLevel.WARNING, e, t);
    }, e.prototype.error = function (e) {
      for (var t = [], r = 1; r < arguments.length; r++) t[r - 1] = arguments[r];
      this.namedLog(exports.LogLevel.ERROR, e, t);
    }, e.prototype.format = function (e) {
      return "".concat(this.messagePrefix ? this.messagePrefix + ": " : "").concat(N.apply(void 0, c([e.message], e.splat, !1)));
    }, e.prototype.internalLog = function (e, t) {
      P && (e < C || (P.log(e, this.format(t)), t.error && t.error instanceof Error && d().handleError(t.error)));
    }, e.prototype.namedLog = function (e, t, r) {
      var i;
      if (t instanceof Error) return t = (i = t).message, void this.internalLog(e, {
        error: i,
        message: t,
        splat: r
      });
      if (0 !== r.length) {
        var n = r[r.length - 1];
        n instanceof Error && (i = n, r.splice(-1)), this.internalLog(e, {
          message: t,
          error: i,
          splat: r
        });
      } else this.internalLog(e, {
        message: t,
        splat: r
      });
    }, e;
  }(),
  V = new L();
function M(e) {
  return V.getLogger(e);
}
function F(e) {
  P = e;
}
var x = {
  setLogLevel: function setLogLevel(e) {
    e = S(e), C = _(exports.LogLevel, e) && void 0 !== e ? e : exports.LogLevel.ERROR;
  },
  setLogHandler: F
};
function k(e, t) {
  var r = e.context,
    i = t.context;
  return r.accountId === i.accountId && r.projectId === i.projectId && r.clientName === i.clientName && r.clientVersion === i.clientVersion && r.revision === i.revision && r.anonymizeIP === i.anonymizeIP && r.botFiltering === i.botFiltering;
}
var w,
  G = M("EventProcessor"),
  B = function () {
    function e(e) {
      var t = e.timeout,
        r = e.callback;
      this.timeout = Math.max(t, 0), this.callback = r;
    }
    return e.prototype.start = function () {
      this.timeoutId = setTimeout(this.callback, this.timeout);
    }, e.prototype.refresh = function () {
      this.stop(), this.start();
    }, e.prototype.stop = function () {
      this.timeoutId && clearTimeout(this.timeoutId);
    }, e;
  }(),
  K = function () {
    function e(e) {
      var t = e.sink;
      this.sink = t;
    }
    return e.prototype.start = function () {
      return Promise.resolve();
    }, e.prototype.stop = function () {
      return Promise.resolve();
    }, e.prototype.enqueue = function (e) {
      this.sink([e]);
    }, e;
  }(),
  j = function () {
    function e(e) {
      var t = e.flushInterval,
        r = e.maxQueueSize,
        i = e.sink,
        n = e.closingSink,
        o = e.batchComparator;
      this.buffer = [], this.maxQueueSize = Math.max(r, 1), this.sink = i, this.closingSink = n, this.batchComparator = o, this.timer = new B({
        callback: this.flush.bind(this),
        timeout: t
      }), this.started = !1;
    }
    return e.prototype.start = function () {
      return this.started = !0, Promise.resolve();
    }, e.prototype.stop = function () {
      this.started = !1;
      var e = this.closingSink ? this.closingSink(this.buffer) : this.sink(this.buffer);
      return this.buffer = [], this.timer.stop(), e;
    }, e.prototype.enqueue = function (e) {
      if (this.started) {
        var t = this.buffer[0];
        t && !this.batchComparator(t, e) && this.flush(), 0 === this.buffer.length && this.timer.refresh(), this.buffer.push(e), this.buffer.length >= this.maxQueueSize && this.flush();
      } else G.warn("Queue is stopped, not accepting event");
    }, e.prototype.flush = function () {
      this.sink(this.buffer), this.buffer = [], this.timer.stop();
    }, e;
  }(),
  q = {
    NOTSET: 0,
    DEBUG: 1,
    INFO: 2,
    WARNING: 3,
    ERROR: 4
  },
  H = {
    BROWSER_ODP_MANAGER_INITIALIZATION_FAILED: "%s: Error initializing Browser ODP Manager.",
    CONDITION_EVALUATOR_ERROR: "%s: Error evaluating audience condition of type %s: %s",
    DATAFILE_AND_SDK_KEY_MISSING: "%s: You must provide at least one of sdkKey or datafile. Cannot start Optimizely",
    EXPERIMENT_KEY_NOT_IN_DATAFILE: "%s: Experiment key %s is not in datafile.",
    FEATURE_NOT_IN_DATAFILE: "%s: Feature key %s is not in datafile.",
    FETCH_SEGMENTS_FAILED_NETWORK_ERROR: "%s: Audience segments fetch failed. (network error)",
    FETCH_SEGMENTS_FAILED_DECODE_ERROR: "%s: Audience segments fetch failed. (decode error)",
    IMPROPERLY_FORMATTED_EXPERIMENT: "%s: Experiment key %s is improperly formatted.",
    INVALID_ATTRIBUTES: "%s: Provided attributes are in an invalid format.",
    INVALID_BUCKETING_ID: "%s: Unable to generate hash for bucketing ID %s: %s",
    INVALID_DATAFILE: "%s: Datafile is invalid - property %s: %s",
    INVALID_DATAFILE_MALFORMED: "%s: Datafile is invalid because it is malformed.",
    INVALID_CONFIG: "%s: Provided Optimizely config is in an invalid format.",
    INVALID_JSON: "%s: JSON object is not valid.",
    INVALID_ERROR_HANDLER: '%s: Provided "errorHandler" is in an invalid format.',
    INVALID_EVENT_DISPATCHER: '%s: Provided "eventDispatcher" is in an invalid format.',
    INVALID_EVENT_TAGS: "%s: Provided event tags are in an invalid format.",
    INVALID_EXPERIMENT_KEY: "%s: Experiment key %s is not in datafile. It is either invalid, paused, or archived.",
    INVALID_EXPERIMENT_ID: "%s: Experiment ID %s is not in datafile.",
    INVALID_GROUP_ID: "%s: Group ID %s is not in datafile.",
    INVALID_LOGGER: '%s: Provided "logger" is in an invalid format.',
    INVALID_ROLLOUT_ID: "%s: Invalid rollout ID %s attached to feature %s",
    INVALID_USER_ID: "%s: Provided user ID is in an invalid format.",
    INVALID_USER_PROFILE_SERVICE: "%s: Provided user profile service instance is in an invalid format: %s.",
    LOCAL_STORAGE_DOES_NOT_EXIST: "Error accessing window localStorage.",
    MISSING_INTEGRATION_KEY: "%s: Integration key missing from datafile. All integrations should include a key.",
    NO_DATAFILE_SPECIFIED: "%s: No datafile specified. Cannot start optimizely.",
    NO_JSON_PROVIDED: "%s: No JSON object to validate against schema.",
    NO_VARIATION_FOR_EXPERIMENT_KEY: "%s: No variation key %s defined in datafile for experiment %s.",
    ODP_CONFIG_NOT_AVAILABLE: "%s: ODP is not integrated to the project.",
    ODP_EVENT_FAILED: "ODP event send failed.",
    ODP_FETCH_QUALIFIED_SEGMENTS_SEGMENTS_MANAGER_MISSING: "%s: ODP unable to fetch qualified segments (Segments Manager not initialized).",
    ODP_IDENTIFY_FAILED_EVENT_MANAGER_MISSING: "%s: ODP identify event %s is not dispatched (Event Manager not instantiated).",
    ODP_INITIALIZATION_FAILED: "%s: ODP failed to initialize.",
    ODP_INVALID_DATA: "%s: ODP data is not valid",
    ODP_EVENT_FAILED_ODP_MANAGER_MISSING: "%s: ODP Event failed to send. (ODP Manager not initialized).",
    ODP_FETCH_QUALIFIED_SEGMENTS_FAILED_ODP_MANAGER_MISSING: "%s: ODP failed to Fetch Qualified Segments. (ODP Manager not initialized).",
    ODP_IDENTIFY_USER_FAILED_ODP_MANAGER_MISSING: "%s: ODP failed to Identify User. (ODP Manager not initialized).",
    ODP_IDENTIFY_USER_FAILED_USER_CONTEXT_INITIALIZATION: "%s: ODP failed to Identify User. (Failed during User Context Initialization).",
    ODP_MANAGER_UPDATE_SETTINGS_FAILED_EVENT_MANAGER_MISSING: "%s: ODP Manager failed to update OdpConfig settings for internal event manager. (Event Manager not initialized).",
    ODP_MANAGER_UPDATE_SETTINGS_FAILED_SEGMENTS_MANAGER_MISSING: "%s: ODP Manager failed to update OdpConfig settings for internal segments manager. (Segments Manager not initialized).",
    ODP_NOT_ENABLED: "ODP is not enabled",
    ODP_NOT_INTEGRATED: "%s: ODP is not integrated",
    ODP_SEND_EVENT_FAILED_EVENT_MANAGER_MISSING: "%s: ODP send event %s was not dispatched (Event Manager not instantiated).",
    ODP_SEND_EVENT_FAILED_UID_MISSING: "%s: ODP send event %s was not dispatched (No valid user identifier provided).",
    ODP_SEND_EVENT_FAILED_VUID_MISSING: "%s: ODP send event %s was not dispatched (Unable to fetch VUID).",
    ODP_VUID_INITIALIZATION_FAILED: "%s: ODP VUID initialization failed.",
    ODP_VUID_REGISTRATION_FAILED: "%s: ODP VUID failed to be registered.",
    ODP_VUID_REGISTRATION_FAILED_EVENT_MANAGER_MISSING: "%s: ODP register vuid failed. (Event Manager not instantiated).",
    UNDEFINED_ATTRIBUTE: "%s: Provided attribute: %s has an undefined value.",
    UNRECOGNIZED_ATTRIBUTE: "%s: Unrecognized attribute %s provided. Pruning before sending event to Optimizely.",
    UNABLE_TO_CAST_VALUE: "%s: Unable to cast value %s to type %s, returning null.",
    USER_NOT_IN_FORCED_VARIATION: "%s: User %s is not in the forced variation map. Cannot remove their forced variation.",
    USER_PROFILE_LOOKUP_ERROR: '%s: Error while looking up user profile for user ID "%s": %s.',
    USER_PROFILE_SAVE_ERROR: '%s: Error while saving user profile for user ID "%s": %s.',
    VARIABLE_KEY_NOT_IN_DATAFILE: '%s: Variable with key "%s" associated with feature with key "%s" is not in datafile.',
    VARIATION_ID_NOT_IN_DATAFILE: "%s: No variation ID %s defined in datafile for experiment %s.",
    VARIATION_ID_NOT_IN_DATAFILE_NO_EXPERIMENT: "%s: Variation ID %s is not in the datafile.",
    INVALID_INPUT_FORMAT: "%s: Provided %s is in an invalid format.",
    INVALID_DATAFILE_VERSION: "%s: This version of the JavaScript SDK does not support the given datafile version: %s",
    INVALID_VARIATION_KEY: "%s: Provided variation key is in an invalid format."
  },
  z = {
    ACTIVATE_USER: "%s: Activating user %s in experiment %s.",
    DISPATCH_CONVERSION_EVENT: "%s: Dispatching conversion event to URL %s with params %s.",
    DISPATCH_IMPRESSION_EVENT: "%s: Dispatching impression event to URL %s with params %s.",
    DEPRECATED_EVENT_VALUE: "%s: Event value is deprecated in %s call.",
    EVENT_KEY_NOT_FOUND: "%s: Event key %s is not in datafile.",
    EXPERIMENT_NOT_RUNNING: "%s: Experiment %s is not running.",
    FEATURE_ENABLED_FOR_USER: "%s: Feature %s is enabled for user %s.",
    FEATURE_NOT_ENABLED_FOR_USER: "%s: Feature %s is not enabled for user %s.",
    FEATURE_HAS_NO_EXPERIMENTS: "%s: Feature %s is not attached to any experiments.",
    FAILED_TO_PARSE_VALUE: '%s: Failed to parse event value "%s" from event tags.',
    FAILED_TO_PARSE_REVENUE: '%s: Failed to parse revenue value "%s" from event tags.',
    FORCED_BUCKETING_FAILED: "%s: Variation key %s is not in datafile. Not activating user %s.",
    INVALID_OBJECT: "%s: Optimizely object is not valid. Failing %s.",
    INVALID_CLIENT_ENGINE: "%s: Invalid client engine passed: %s. Defaulting to node-sdk.",
    INVALID_DEFAULT_DECIDE_OPTIONS: "%s: Provided default decide options is not an array.",
    INVALID_DECIDE_OPTIONS: "%s: Provided decide options is not an array. Using default decide options.",
    INVALID_VARIATION_ID: "%s: Bucketed into an invalid variation ID. Returning null.",
    NOTIFICATION_LISTENER_EXCEPTION: "%s: Notification listener for (%s) threw exception: %s",
    NO_ROLLOUT_EXISTS: "%s: There is no rollout of feature %s.",
    NOT_ACTIVATING_USER: "%s: Not activating user %s for experiment %s.",
    NOT_TRACKING_USER: "%s: Not tracking user %s.",
    ODP_DISABLED: "ODP Disabled.",
    ODP_IDENTIFY_FAILED_ODP_DISABLED: "%s: ODP identify event for user %s is not dispatched (ODP disabled).",
    ODP_IDENTIFY_FAILED_ODP_NOT_INTEGRATED: "%s: ODP identify event %s is not dispatched (ODP not integrated).",
    ODP_SEND_EVENT_IDENTIFIER_CONVERSION_FAILED: "%s: sendOdpEvent failed to parse through and convert fs_user_id aliases",
    PARSED_REVENUE_VALUE: '%s: Parsed revenue value "%s" from event tags.',
    PARSED_NUMERIC_VALUE: '%s: Parsed event value "%s" from event tags.',
    RETURNING_STORED_VARIATION: '%s: Returning previously activated variation "%s" of experiment "%s" for user "%s" from user profile.',
    ROLLOUT_HAS_NO_EXPERIMENTS: "%s: Rollout of feature %s has no experiments",
    SAVED_VARIATION: '%s: Saved variation "%s" of experiment "%s" for user "%s".',
    SAVED_VARIATION_NOT_FOUND: "%s: User %s was previously bucketed into variation with ID %s for experiment %s, but no matching variation was found.",
    SHOULD_NOT_DISPATCH_ACTIVATE: '%s: Experiment %s is not in "Running" state. Not activating user.',
    SKIPPING_JSON_VALIDATION: "%s: Skipping JSON schema validation.",
    TRACK_EVENT: "%s: Tracking event %s for user %s.",
    UNRECOGNIZED_DECIDE_OPTION: "%s: Unrecognized decide option %s provided.",
    USER_ASSIGNED_TO_EXPERIMENT_BUCKET: "%s: Assigned bucket %s to user with bucketing ID %s.",
    USER_BUCKETED_INTO_EXPERIMENT_IN_GROUP: "%s: User %s is in experiment %s of group %s.",
    USER_BUCKETED_INTO_TARGETING_RULE: "%s: User %s bucketed into targeting rule %s.",
    USER_IN_FEATURE_EXPERIMENT: "%s: User %s is in variation %s of experiment %s on the feature %s.",
    USER_IN_ROLLOUT: "%s: User %s is in rollout of feature %s.",
    USER_NOT_BUCKETED_INTO_EVERYONE_TARGETING_RULE: "%s: User %s not bucketed into everyone targeting rule due to traffic allocation.",
    USER_NOT_BUCKETED_INTO_EXPERIMENT_IN_GROUP: "%s: User %s is not in experiment %s of group %s.",
    USER_NOT_BUCKETED_INTO_ANY_EXPERIMENT_IN_GROUP: "%s: User %s is not in any experiment of group %s.",
    USER_NOT_BUCKETED_INTO_TARGETING_RULE: "%s User %s not bucketed into targeting rule %s due to traffic allocation. Trying everyone rule.",
    USER_NOT_IN_FEATURE_EXPERIMENT: "%s: User %s is not in any experiment on the feature %s.",
    USER_NOT_IN_ROLLOUT: "%s: User %s is not in rollout of feature %s.",
    USER_FORCED_IN_VARIATION: "%s: User %s is forced in variation %s.",
    USER_MAPPED_TO_FORCED_VARIATION: "%s: Set variation %s for experiment %s and user %s in the forced variation map.",
    USER_DOESNT_MEET_CONDITIONS_FOR_TARGETING_RULE: "%s: User %s does not meet conditions for targeting rule %s.",
    USER_MEETS_CONDITIONS_FOR_TARGETING_RULE: "%s: User %s meets conditions for targeting rule %s.",
    USER_HAS_VARIATION: "%s: User %s is in variation %s of experiment %s.",
    USER_HAS_FORCED_DECISION_WITH_RULE_SPECIFIED: "Variation (%s) is mapped to flag (%s), rule (%s) and user (%s) in the forced decision map.",
    USER_HAS_FORCED_DECISION_WITH_NO_RULE_SPECIFIED: "Variation (%s) is mapped to flag (%s) and user (%s) in the forced decision map.",
    USER_HAS_FORCED_DECISION_WITH_RULE_SPECIFIED_BUT_INVALID: "Invalid variation is mapped to flag (%s), rule (%s) and user (%s) in the forced decision map.",
    USER_HAS_FORCED_DECISION_WITH_NO_RULE_SPECIFIED_BUT_INVALID: "Invalid variation is mapped to flag (%s) and user (%s) in the forced decision map.",
    USER_HAS_FORCED_VARIATION: "%s: Variation %s is mapped to experiment %s and user %s in the forced variation map.",
    USER_HAS_NO_VARIATION: "%s: User %s is in no variation of experiment %s.",
    USER_HAS_NO_FORCED_VARIATION: "%s: User %s is not in the forced variation map.",
    USER_HAS_NO_FORCED_VARIATION_FOR_EXPERIMENT: "%s: No experiment %s mapped to user %s in the forced variation map.",
    USER_NOT_IN_ANY_EXPERIMENT: "%s: User %s is not in any experiment of group %s.",
    USER_NOT_IN_EXPERIMENT: "%s: User %s does not meet conditions to be in experiment %s.",
    USER_RECEIVED_DEFAULT_VARIABLE_VALUE: '%s: User "%s" is not in any variation or rollout rule. Returning default value for variable "%s" of feature flag "%s".',
    FEATURE_NOT_ENABLED_RETURN_DEFAULT_VARIABLE_VALUE: '%s: Feature "%s" is not enabled for user %s. Returning the default variable value "%s".',
    VARIABLE_NOT_USED_RETURN_DEFAULT_VARIABLE_VALUE: '%s: Variable "%s" is not used in variation "%s". Returning default value.',
    USER_RECEIVED_VARIABLE_VALUE: '%s: Got variable value "%s" for variable "%s" of feature flag "%s"',
    VALID_DATAFILE: "%s: Datafile is valid.",
    VALID_USER_PROFILE_SERVICE: "%s: Valid user profile service provided.",
    VARIATION_REMOVED_FOR_USER: "%s: Variation mapped to experiment %s has been removed for user %s.",
    VARIABLE_REQUESTED_WITH_WRONG_TYPE: '%s: Requested variable type "%s", but variable is of type "%s". Use correct API to retrieve value. Returning None.',
    VALID_BUCKETING_ID: '%s: BucketingId is valid: "%s"',
    BUCKETING_ID_NOT_STRING: "%s: BucketingID attribute is not a string. Defaulted to userId",
    EVALUATING_AUDIENCE: '%s: Starting to evaluate audience "%s" with conditions: %s.',
    EVALUATING_AUDIENCES_COMBINED: '%s: Evaluating audiences for %s "%s": %s.',
    AUDIENCE_EVALUATION_RESULT: '%s: Audience "%s" evaluated to %s.',
    AUDIENCE_EVALUATION_RESULT_COMBINED: "%s: Audiences for %s %s collectively evaluated to %s.",
    MISSING_ATTRIBUTE_VALUE: '%s: Audience condition %s evaluated to UNKNOWN because no value was passed for user attribute "%s".',
    UNEXPECTED_CONDITION_VALUE: "%s: Audience condition %s evaluated to UNKNOWN because the condition value is not supported.",
    UNEXPECTED_TYPE: '%s: Audience condition %s evaluated to UNKNOWN because a value of type "%s" was passed for user attribute "%s".',
    UNEXPECTED_TYPE_NULL: '%s: Audience condition %s evaluated to UNKNOWN because a null value was passed for user attribute "%s".',
    UNKNOWN_CONDITION_TYPE: "%s: Audience condition %s has an unknown condition type. You may need to upgrade to a newer release of the Optimizely SDK.",
    UNKNOWN_MATCH_TYPE: "%s: Audience condition %s uses an unknown match type. You may need to upgrade to a newer release of the Optimizely SDK.",
    UPDATED_OPTIMIZELY_CONFIG: "%s: Updated Optimizely config to revision %s (project id %s)",
    OUT_OF_BOUNDS: '%s: Audience condition %s evaluated to UNKNOWN because the number value for user attribute "%s" is not in the range [-2^53, +2^53].',
    UNABLE_TO_ATTACH_UNLOAD: '%s: unable to bind optimizely.close() to page unload event: "%s"'
  },
  Y = {
    BOT_FILTERING: "$opt_bot_filtering",
    BUCKETING_ID: "$opt_bucketing_id",
    STICKY_BUCKETING_KEY: "$opt_experiment_bucket_map",
    USER_AGENT: "$opt_user_agent",
    FORCED_DECISION_NULL_RULE_KEY: "$opt_null_rule_key"
  },
  X = {
    AB_TEST: "ab-test",
    FEATURE: "feature",
    FEATURE_TEST: "feature-test",
    FEATURE_VARIABLE: "feature-variable",
    ALL_FEATURE_VARIABLES: "all-feature-variables",
    FLAG: "flag"
  },
  J = {
    FEATURE_TEST: "feature-test",
    ROLLOUT: "rollout",
    EXPERIMENT: "experiment"
  },
  W = {
    RULE: "rule",
    EXPERIMENT: "experiment"
  },
  Z = {
    BOOLEAN: "boolean",
    DOUBLE: "double",
    INTEGER: "integer",
    STRING: "string",
    JSON: "json"
  },
  Q = {
    V2: "2",
    V3: "3",
    V4: "4"
  },
  $ = {
    SDK_NOT_READY: "Optimizely SDK not configured properly yet.",
    FLAG_KEY_INVALID: 'No flag was found for key "%s".',
    VARIABLE_VALUE_INVALID: 'Variable value for key "%s" is invalid or wrong type.'
  };
!function (e) {
  e.ACTIVATE = "ACTIVATE:experiment, user_id,attributes, variation, event", e.DECISION = "DECISION:type, userId, attributes, decisionInfo", e.LOG_EVENT = "LOG_EVENT:logEvent", e.OPTIMIZELY_CONFIG_UPDATE = "OPTIMIZELY_CONFIG_UPDATE", e.TRACK = "TRACK:event_key, user_id, attributes, event_tags, event";
}(w || (w = {}));
var ee;
!function (e) {
  e.VUID = "vuid", e.FS_USER_ID = "fs_user_id";
}(ee || (ee = {}));
var te;
!function (e) {
  e.IDENTIFIED = "identified", e.INITIALIZED = "client_initialized";
}(te || (te = {}));
var re = Object.freeze({
    __proto__: null,
    LOG_LEVEL: q,
    ERROR_MESSAGES: H,
    LOG_MESSAGES: z,
    CONTROL_ATTRIBUTES: Y,
    JAVASCRIPT_CLIENT_ENGINE: "javascript-sdk",
    NODE_CLIENT_ENGINE: "node-sdk",
    REACT_CLIENT_ENGINE: "react-sdk",
    REACT_NATIVE_CLIENT_ENGINE: "react-native-sdk",
    REACT_NATIVE_JS_CLIENT_ENGINE: "react-native-js-sdk",
    CLIENT_VERSION: "5.3.5",
    DECISION_NOTIFICATION_TYPES: X,
    DECISION_SOURCES: J,
    AUDIENCE_EVALUATION_TYPES: W,
    FEATURE_VARIABLE_TYPES: Z,
    DATAFILE_VERSIONS: Q,
    DECISION_MESSAGES: $,
    get NOTIFICATION_TYPES() {
      return w;
    },
    REQUEST_TIMEOUT_MS: 6e4,
    REQUEST_TIMEOUT_ODP_SEGMENTS_MS: 1e4,
    REQUEST_TIMEOUT_ODP_EVENTS_MS: 1e4,
    get ODP_USER_KEY() {
      return ee;
    },
    FS_USER_ID_ALIAS: "fs-user-id",
    ODP_DEFAULT_EVENT_TYPE: "fullstack",
    get ODP_EVENT_ACTION() {
      return te;
    }
  }),
  ie = M("EventProcessor");
var ne = M("EventProcessor"),
  oe = function () {
    function e(e) {
      var t = e.key,
        r = e.maxValues,
        i = void 0 === r ? 1e3 : r;
      this.LS_KEY = t, this.maxValues = i;
    }
    return e.prototype.get = function (e) {
      return this.getMap()[e] || null;
    }, e.prototype.set = function (e, t) {
      var r = this.getMap();
      r[e] = t, this.replace(r);
    }, e.prototype.remove = function (e) {
      var t = this.getMap();
      delete t[e], this.replace(t);
    }, e.prototype.values = function () {
      return v(this.getMap());
    }, e.prototype.clear = function () {
      this.replace({});
    }, e.prototype.replace = function (e) {
      try {
        "undefined" != typeof window ? window && window.localStorage && localStorage.setItem(this.LS_KEY, JSON.stringify(e)) : localStorage.setItem(this.LS_KEY, JSON.stringify(e)), this.clean();
      } catch (e) {
        ne.error(String(e));
      }
    }, e.prototype.clean = function () {
      var e = this.getMap(),
        t = Object.keys(e),
        r = t.length - this.maxValues;
      if (!(r < 1)) {
        var i = t.map(function (t) {
          return {
            key: t,
            value: e[t]
          };
        });
        i.sort(function (e, t) {
          return e.value.timestamp - t.value.timestamp;
        });
        for (var n = 0; n < r; n++) delete e[i[n].key];
        this.replace(e);
      }
    }, e.prototype.getMap = function () {
      try {
        var e = "undefined" != typeof window ? window && window.localStorage && localStorage.getItem(this.LS_KEY) : localStorage.getItem(this.LS_KEY);
        if (e) return JSON.parse(e) || {};
      } catch (e) {
        ne.error(e);
      }
      return {};
    }, e;
  }(),
  se = M("EventProcessor"),
  ae = function (e) {
    function t(t) {
      var r = t.eventDispatcher;
      return e.call(this, {
        eventDispatcher: r,
        store: new oe({
          maxValues: 100,
          key: "fs_optly_pending_events"
        })
      }) || this;
    }
    return s(t, e), t;
  }(function () {
    function e(e) {
      var t = e.eventDispatcher,
        r = e.store;
      this.dispatcher = t, this.store = r;
    }
    return e.prototype.dispatchEvent = function (e, t) {
      this.send({
        uuid: h(),
        timestamp: I(),
        request: e
      }, t);
    }, e.prototype.sendPendingEvents = function () {
      var e = this,
        t = this.store.values();
      se.debug("Sending %s pending events from previous page", t.length), t.forEach(function (t) {
        try {
          e.send(t, function () {});
        } catch (e) {
          se.debug(String(e));
        }
      });
    }, e.prototype.send = function (e, t) {
      var r = this;
      this.store.set(e.uuid, e), this.dispatcher.dispatchEvent(e.request, function (i) {
        r.store.remove(e.uuid), t(i);
      });
    }, e;
  }());
function ue(e) {
  var t = [],
    r = e[0];
  return e.forEach(function (e) {
    if ("conversion" === e.type || "impression" === e.type) {
      var r = function (e) {
        var t = {
          snapshots: [],
          visitor_id: e.user.id,
          attributes: []
        };
        e.user.attributes.forEach(function (e) {
          t.attributes.push({
            entity_id: e.entityId,
            key: e.key,
            type: "custom",
            value: e.value
          });
        }), "boolean" == typeof e.context.botFiltering && t.attributes.push({
          entity_id: "$opt_bot_filtering",
          key: "$opt_bot_filtering",
          type: "custom",
          value: e.context.botFiltering
        });
        return t;
      }(e);
      "impression" === e.type ? r.snapshots.push(function (e) {
        var t,
          r,
          i = e.layer,
          n = e.experiment,
          o = e.variation,
          s = e.ruleKey,
          a = e.flagKey,
          u = e.ruleType,
          l = e.enabled,
          c = i ? i.id : null,
          p = null !== (t = null == n ? void 0 : n.id) && void 0 !== t ? t : "",
          d = null !== (r = null == o ? void 0 : o.id) && void 0 !== r ? r : "",
          f = o ? o.key : "";
        return {
          decisions: [{
            campaign_id: c,
            experiment_id: p,
            variation_id: d,
            metadata: {
              flag_key: a,
              rule_key: s,
              rule_type: u,
              variation_key: f,
              enabled: l
            }
          }],
          events: [{
            entity_id: c,
            timestamp: e.timestamp,
            key: "campaign_activated",
            uuid: e.uuid
          }]
        };
      }(e)) : "conversion" === e.type && r.snapshots.push(function (e) {
        var t = _a({}, e.tags);
        delete t.revenue, delete t.value;
        var r = {
          entity_id: e.event.id,
          key: e.event.key,
          timestamp: e.timestamp,
          uuid: e.uuid
        };
        e.tags && (r.tags = e.tags);
        null != e.value && (r.value = e.value);
        null != e.revenue && (r.revenue = e.revenue);
        return {
          events: [r]
        };
      }(e)), t.push(r);
    }
  }), {
    client_name: r.context.clientName,
    client_version: r.context.clientVersion,
    account_id: r.context.accountId,
    project_id: r.context.projectId,
    revision: r.context.revision,
    anonymize_ip: r.context.anonymizeIP,
    enrich_decisions: !0,
    visitors: t
  };
}
var le = function () {
    function e() {
      this.reqsInFlightCount = 0, this.reqsCompleteResolvers = [];
    }
    return e.prototype.trackRequest = function (e) {
      var t = this;
      this.reqsInFlightCount++;
      var r = function r() {
        t.reqsInFlightCount--, 0 === t.reqsInFlightCount && (t.reqsCompleteResolvers.forEach(function (e) {
          return e();
        }), t.reqsCompleteResolvers = []);
      };
      e.then(r, r);
    }, e.prototype.onRequestsComplete = function () {
      var e = this;
      return new Promise(function (t) {
        0 === e.reqsInFlightCount ? t() : e.reqsCompleteResolvers.push(t);
      });
    }, e;
  }(),
  ce = M("LogTierV1EventProcessor"),
  pe = function () {
    function e(e) {
      var t = e.dispatcher,
        r = e.closingDispatcher,
        i = e.flushInterval,
        n = void 0 === i ? 3e4 : i,
        o = e.batchSize,
        s = void 0 === o ? 10 : o,
        a = e.notificationCenter;
      this.dispatcher = t, this.closingDispatcher = r, this.notificationCenter = a, this.requestTracker = new le(), n = function (e) {
        return e <= 0 && (ie.warn("Invalid flushInterval ".concat(e, ", defaulting to ").concat(3e4)), e = 3e4), e;
      }(n), s = function (e) {
        return (e = Math.floor(e)) < 1 && (ie.warn("Invalid batchSize ".concat(e, ", defaulting to ").concat(10)), e = 10), e = Math.max(1, e);
      }(s), this.queue = function (e, t, r, i, n) {
        return e > 1 ? new j({
          flushInterval: t,
          maxQueueSize: e,
          sink: i,
          closingSink: n,
          batchComparator: r
        }) : new K({
          sink: i
        });
      }(s, n, k, this.drainQueue.bind(this, !1), this.drainQueue.bind(this, !0));
    }
    return e.prototype.drainQueue = function (e, t) {
      var r = this,
        i = new Promise(function (i) {
          if (ce.debug("draining queue with %s events", t.length), 0 !== t.length) {
            var n,
              o,
              s = {
                url: "https://logx.optimizely.com/v1/events",
                httpVerb: "POST",
                params: ue(t)
              };
            (e && r.closingDispatcher ? r.closingDispatcher : r.dispatcher).dispatchEvent(s, function () {
              i();
            }), n = r.notificationCenter, o = s, n && n.sendNotifications(w.LOG_EVENT, o);
          } else i();
        });
      return this.requestTracker.trackRequest(i), i;
    }, e.prototype.process = function (e) {
      this.queue.enqueue(e);
    }, e.prototype.stop = function () {
      try {
        return this.queue.stop(), this.requestTracker.onRequestsComplete();
      } catch (e) {
        ce.error('Error stopping EventProcessor: "%s"', Object(e).message, String(e));
      }
      return Promise.resolve();
    }, e.prototype.start = function () {
      return u(this, void 0, void 0, function () {
        return l(this, function (e) {
          switch (e.label) {
            case 0:
              return [4, this.queue.start()];
            case 1:
              return e.sent(), [2];
          }
        });
      });
    }, e;
  }(),
  de = "CONFIG_VALIDATOR",
  fe = [Q.V2, Q.V3, Q.V4],
  ge = function ge(e) {
    if ("object" == typeof e && null !== e) {
      var t = e,
        r = t.errorHandler,
        i = t.eventDispatcher,
        n = t.logger;
      if (r && "function" != typeof r.handleError) throw new Error(N(H.INVALID_ERROR_HANDLER, de));
      if (i && "function" != typeof i.dispatchEvent) throw new Error(N(H.INVALID_EVENT_DISPATCHER, de));
      if (n && "function" != typeof n.log) throw new Error(N(H.INVALID_LOGGER, de));
      return !0;
    }
    throw new Error(N(H.INVALID_CONFIG, de));
  },
  Ee = function Ee(e) {
    if (!e) throw new Error(N(H.NO_DATAFILE_SPECIFIED, de));
    if ("string" == typeof e) try {
      e = JSON.parse(e);
    } catch (e) {
      throw new Error(N(H.INVALID_DATAFILE_MALFORMED, de));
    }
    if ("object" == typeof e && !Array.isArray(e) && null !== e && -1 === fe.indexOf(e.version)) throw new Error(N(H.INVALID_DATAFILE_VERSION, de, e.version));
    return e;
  };
var he = {
    handleError: function handleError() {}
  },
  Ie = function Ie(e) {
    return Object.keys(e).map(function (t) {
      return encodeURIComponent(t) + "=" + encodeURIComponent(e[t]);
    }).join("&");
  },
  _e = {
    dispatchEvent: function dispatchEvent(e, t) {
      var r,
        i = e.params,
        n = e.url;
      "POST" === e.httpVerb ? ((r = new XMLHttpRequest()).open("POST", n, !0), r.setRequestHeader("Content-Type", "application/json"), r.onreadystatechange = function () {
        if (4 === r.readyState && t && "function" == typeof t) try {
          t({
            statusCode: r.status
          });
        } catch (e) {}
      }, r.send(JSON.stringify(i))) : (n += "?wxhr=true", i && (n += "&" + Ie(i)), (r = new XMLHttpRequest()).open("GET", n, !0), r.onreadystatechange = function () {
        if (4 === r.readyState && t && "function" == typeof t) try {
          t({
            statusCode: r.status
          });
        } catch (e) {}
      }, r.send());
    }
  },
  ve = {
    dispatchEvent: function dispatchEvent(e, t) {
      var r = e.params,
        i = e.url,
        n = new Blob([JSON.stringify(r)], {
          type: "application/json"
        });
      t({
        statusCode: navigator.sendBeacon(i, n) ? 200 : 500
      });
    }
  },
  ye = function () {
    function e() {}
    return e.prototype.log = function () {}, e;
  }();
function Oe(e) {
  return new U(e);
}
var Re = Object.freeze({
    __proto__: null,
    NoOpLogger: ye,
    createLogger: Oe,
    createNoOpLogger: function createNoOpLogger() {
      return new ye();
    }
  }),
  Ne = function Ne(e) {
    return !("number" != typeof e || !A.isSafeInteger(e)) && e >= 1;
  },
  Te = function Te(e) {
    return !("number" != typeof e || !A.isSafeInteger(e)) && e > 0;
  },
  me = function () {
    function e(e) {
      var t = this;
      this.logger = e.logger, this.errorHandler = e.errorHandler, this.notificationListeners = {}, v(w).forEach(function (e) {
        t.notificationListeners[e] = [];
      }), this.listenerId = 1;
    }
    return e.prototype.addNotificationListener = function (e, t) {
      try {
        if (!(v(w).indexOf(e) > -1)) return -1;
        this.notificationListeners[e] || (this.notificationListeners[e] = []);
        var r = !1;
        if ((this.notificationListeners[e] || []).forEach(function (e) {
          e.callback !== t || (r = !0);
        }), r) return -1;
        this.notificationListeners[e].push({
          id: this.listenerId,
          callback: t
        });
        var i = this.listenerId;
        return this.listenerId += 1, i;
      } catch (e) {
        return this.logger.log(q.ERROR, e.message), this.errorHandler.handleError(e), -1;
      }
    }, e.prototype.removeNotificationListener = function (e) {
      var t = this;
      try {
        var r, i;
        if (Object.keys(this.notificationListeners).some(function (n) {
          return (t.notificationListeners[n] || []).every(function (t, o) {
            return t.id !== e || (r = o, i = n, !1);
          }), void 0 !== r && void 0 !== i;
        }), void 0 !== r && void 0 !== i) return this.notificationListeners[i].splice(r, 1), !0;
      } catch (e) {
        this.logger.log(q.ERROR, e.message), this.errorHandler.handleError(e);
      }
      return !1;
    }, e.prototype.clearAllNotificationListeners = function () {
      var e = this;
      try {
        v(w).forEach(function (t) {
          e.notificationListeners[t] = [];
        });
      } catch (e) {
        this.logger.log(q.ERROR, e.message), this.errorHandler.handleError(e);
      }
    }, e.prototype.clearNotificationListeners = function (e) {
      try {
        this.notificationListeners[e] = [];
      } catch (e) {
        this.logger.log(q.ERROR, e.message), this.errorHandler.handleError(e);
      }
    }, e.prototype.sendNotifications = function (e, t) {
      var r = this;
      try {
        (this.notificationListeners[e] || []).forEach(function (i) {
          var n = i.callback;
          try {
            n(t);
          } catch (t) {
            r.logger.log(q.ERROR, z.NOTIFICATION_LISTENER_EXCEPTION, "NOTIFICATION_CENTER", e, t.message);
          }
        });
      } catch (e) {
        this.logger.log(q.ERROR, e.message), this.errorHandler.handleError(e);
      }
    }, e;
  }();
function Ae(e) {
  return new me(e);
}
var De,
  Se,
  Le,
  Ue = {
    createEventProcessor: function createEventProcessor() {
      for (var e = [], t = 0; t < arguments.length; t++) e[t] = arguments[t];
      return new (pe.bind.apply(pe, c([void 0], e, !1)))();
    },
    LocalStoragePendingEventsDispatcher: ae
  };
(De = exports.OptimizelySegmentOption || (exports.OptimizelySegmentOption = {})).IGNORE_CACHE = "IGNORE_CACHE", De.RESET_CACHE = "RESET_CACHE", function (e) {
  e.BOOLEAN = "boolean", e.DOUBLE = "double", e.INTEGER = "integer", e.STRING = "string", e.JSON = "json";
}(Se || (Se = {})), (Le = exports.OptimizelyDecideOption || (exports.OptimizelyDecideOption = {})).DISABLE_DECISION_EVENT = "DISABLE_DECISION_EVENT", Le.ENABLED_FLAGS_ONLY = "ENABLED_FLAGS_ONLY", Le.IGNORE_USER_PROFILE_SERVICE = "IGNORE_USER_PROFILE_SERVICE", Le.INCLUDE_REASONS = "INCLUDE_REASONS", Le.EXCLUDE_VARIABLES = "EXCLUDE_VARIABLES";
var Ce = "Polling intervals below ".concat(30, " seconds are not recommended."),
  Pe = [0, 8, 16, 32, 64, 128, 256, 512],
  be = M("DatafileManager");
function Ve(e, t) {
  var r = new XMLHttpRequest();
  return {
    responsePromise: new Promise(function (i, n) {
      r.open("GET", e, !0), function (e, t) {
        Object.keys(e).forEach(function (r) {
          var i = e[r];
          t.setRequestHeader(r, i);
        });
      }(t, r), r.onreadystatechange = function () {
        if (4 === r.readyState) {
          if (0 === r.status) return void n(new Error("Request error"));
          var e = function (e) {
              var t = e.getAllResponseHeaders();
              if (null === t) return {};
              var r = t.split("\r\n"),
                i = {};
              return r.forEach(function (e) {
                var t = e.indexOf(": ");
                if (t > -1) {
                  var r = e.slice(0, t),
                    n = e.slice(t + 2);
                  n.length > 0 && (i[r] = n);
                }
              }), i;
            }(r),
            t = {
              statusCode: r.status,
              body: r.responseText,
              headers: e
            };
          i(t);
        }
      }, r.timeout = 6e4, r.ontimeout = function () {
        be.error("Request timed out");
      }, r.send();
    }),
    abort: function abort() {
      r.abort();
    }
  };
}
var Me = function () {
  function e() {
    this.listeners = {}, this.listenerId = 1;
  }
  return e.prototype.on = function (e, t) {
    var r = this;
    this.listeners[e] || (this.listeners[e] = {});
    var i = String(this.listenerId);
    return this.listenerId++, this.listeners[e][i] = t, function () {
      r.listeners[e] && delete r.listeners[e][i];
    };
  }, e.prototype.emit = function (e, t) {
    var r = this.listeners[e];
    r && Object.keys(r).forEach(function (e) {
      (0, r[e])(t);
    });
  }, e.prototype.removeAllListeners = function () {
    this.listeners = {};
  }, e;
}();
var Fe = function () {
    function e() {
      this.errorCount = 0;
    }
    return e.prototype.getDelay = function () {
      return 0 === this.errorCount ? 0 : 1e3 * Pe[Math.min(Pe.length - 1, this.errorCount)] + Math.round(1e3 * Math.random());
    }, e.prototype.countError = function () {
      this.errorCount < Pe.length - 1 && this.errorCount++;
    }, e.prototype.reset = function () {
      this.errorCount = 0;
    }, e;
  }(),
  xe = function () {
    function e() {}
    return e.getNotificationCenter = function (e, t) {
      var r;
      if (void 0 === t && (t = M()), e) return this._notificationCenters.has(e) ? r = this._notificationCenters.get(e) : (r = Ae({
        logger: t,
        errorHandler: {
          handleError: function handleError() {}
        }
      }), this._notificationCenters.set(e, r)), r;
      t.log(exports.LogLevel.ERROR, "No SDK key provided to getNotificationCenter.");
    }, e.removeNotificationCenter = function (e) {
      if (e) {
        var t = this._notificationCenters.get(e);
        t && (t.clearAllNotificationListeners(), this._notificationCenters.delete(e));
      }
    }, e._notificationCenters = new Map(), e;
  }(),
  ke = M("DatafileManager");
function we(e) {
  return e >= 200 && e < 400;
}
var Ge = {
    get: function get() {
      return Promise.resolve(void 0);
    },
    set: function set() {
      return Promise.resolve();
    },
    contains: function contains() {
      return Promise.resolve(!1);
    },
    remove: function remove() {
      return Promise.resolve(!1);
    }
  },
  Be = function (e) {
    function t() {
      return null !== e && e.apply(this, arguments) || this;
    }
    return s(t, e), t.prototype.makeGetRequest = function (e, t) {
      return Ve(e, t);
    }, t.prototype.getConfigDefaults = function () {
      return {
        autoUpdate: !1
      };
    }, t;
  }(function () {
    function e(e) {
      var t = this,
        r = _a(_a({}, this.getConfigDefaults()), e),
        i = r.datafile,
        n = r.autoUpdate,
        o = void 0 !== n && n,
        s = r.sdkKey,
        u = r.updateInterval,
        l = void 0 === u ? 3e5 : u,
        c = r.urlTemplate,
        p = void 0 === c ? "https://cdn.optimizely.com/datafiles/%s.json" : c,
        d = r.cache,
        f = void 0 === d ? Ge : d;
      this.cache = f, this.cacheKey = "opt-datafile-" + s, this.sdkKey = s, this.isReadyPromiseSettled = !1, this.readyPromiseResolver = function () {}, this.readyPromiseRejecter = function () {}, this.readyPromise = new Promise(function (e, r) {
        t.readyPromiseResolver = e, t.readyPromiseRejecter = r;
      }), i ? (this.currentDatafile = i, s || this.resolveReadyPromise()) : this.currentDatafile = "", this.isStarted = !1, this.datafileUrl = N(p, s), this.emitter = new Me(), this.autoUpdate = o, this.updateInterval = l, this.updateInterval < 3e4 && ke.warn(Ce), this.currentTimeout = null, this.currentRequest = null, this.backoffController = new Fe(), this.syncOnCurrentRequestComplete = !1;
    }
    return e.prototype.get = function () {
      return this.currentDatafile;
    }, e.prototype.start = function () {
      this.isStarted || (ke.debug("Datafile manager started"), this.isStarted = !0, this.backoffController.reset(), this.setDatafileFromCacheIfAvailable(), this.syncDatafile());
    }, e.prototype.stop = function () {
      return ke.debug("Datafile manager stopped"), this.isStarted = !1, this.currentTimeout && (clearTimeout(this.currentTimeout), this.currentTimeout = null), this.emitter.removeAllListeners(), this.currentRequest && (this.currentRequest.abort(), this.currentRequest = null), Promise.resolve();
    }, e.prototype.onReady = function () {
      return this.readyPromise;
    }, e.prototype.on = function (e, t) {
      return this.emitter.on(e, t);
    }, e.prototype.onRequestRejected = function (e) {
      this.isStarted && (this.backoffController.countError(), e instanceof Error ? ke.error("Error fetching datafile: %s", e.message, e) : "string" == typeof e ? ke.error("Error fetching datafile: %s", e) : ke.error("Error fetching datafile"));
    }, e.prototype.onRequestResolved = function (e) {
      var t;
      if (this.isStarted) {
        void 0 !== e.statusCode && we(e.statusCode) ? this.backoffController.reset() : this.backoffController.countError(), this.trySavingLastModified(e.headers);
        var r = this.getNextDatafileFromResponse(e);
        if ("" !== r) if (ke.info("Updating datafile from response"), this.currentDatafile = r, this.cache.set(this.cacheKey, r), this.isReadyPromiseSettled) {
          var i = {
            datafile: r
          };
          null === (t = xe.getNotificationCenter(this.sdkKey, ke)) || void 0 === t || t.sendNotifications(w.OPTIMIZELY_CONFIG_UPDATE), this.emitter.emit("update", i);
        } else this.resolveReadyPromise();
      }
    }, e.prototype.onRequestComplete = function () {
      this.isStarted && (this.currentRequest = null, this.isReadyPromiseSettled || this.autoUpdate || this.rejectReadyPromise(new Error("Failed to become ready")), this.autoUpdate && this.syncOnCurrentRequestComplete && this.syncDatafile(), this.syncOnCurrentRequestComplete = !1);
    }, e.prototype.syncDatafile = function () {
      var e = this,
        t = {};
      this.lastResponseLastModified && (t["if-modified-since"] = this.lastResponseLastModified), ke.debug("Making datafile request to url %s with headers: %s", this.datafileUrl, function () {
        return JSON.stringify(t);
      }), this.currentRequest = this.makeGetRequest(this.datafileUrl, t);
      var r = function r() {
        e.onRequestComplete();
      };
      this.currentRequest.responsePromise.then(function (t) {
        e.onRequestResolved(t);
      }, function (t) {
        e.onRequestRejected(t);
      }).then(r, r), this.autoUpdate && this.scheduleNextUpdate();
    }, e.prototype.resolveReadyPromise = function () {
      this.readyPromiseResolver(), this.isReadyPromiseSettled = !0;
    }, e.prototype.rejectReadyPromise = function (e) {
      this.readyPromiseRejecter(e), this.isReadyPromiseSettled = !0;
    }, e.prototype.scheduleNextUpdate = function () {
      var e = this,
        t = this.backoffController.getDelay(),
        r = Math.max(t, this.updateInterval);
      ke.debug("Scheduling sync in %s ms", r), this.currentTimeout = setTimeout(function () {
        e.currentRequest ? e.syncOnCurrentRequestComplete = !0 : e.syncDatafile();
      }, r);
    }, e.prototype.getNextDatafileFromResponse = function (e) {
      return ke.debug("Response status code: %s", e.statusCode), void 0 === e.statusCode || 304 === e.statusCode ? "" : we(e.statusCode) ? e.body : (ke.error("Datafile fetch request failed with status: ".concat(e.statusCode)), "");
    }, e.prototype.trySavingLastModified = function (e) {
      var t = e["last-modified"] || e["Last-Modified"];
      void 0 !== t && (this.lastResponseLastModified = t, ke.debug("Saved last modified header value from response: %s", this.lastResponseLastModified));
    }, e.prototype.setDatafileFromCacheIfAvailable = function () {
      var e = this;
      this.cache.get(this.cacheKey).then(function (t) {
        e.isStarted && !e.isReadyPromiseSettled && t && (ke.debug("Using datafile from cache"), e.currentDatafile = t, e.resolveReadyPromise());
      });
    }, e;
  }()),
  Ke = function () {
    function e(e, t, r, i) {
      this.apiKey = e, this.apiHost = t, this.pixelUrl = r, this.segmentsToCheck = i;
    }
    return e.prototype.equals = function (e) {
      return this.apiHost === e.apiHost && this.apiKey === e.apiKey && this.pixelUrl === e.pixelUrl && T(this.segmentsToCheck, e.segmentsToCheck);
    }, e;
  }(),
  je = "PROJECT_CONFIG";
var qe = function qe(e, t) {
    void 0 === t && (t = null);
    var r,
      i,
      n,
      o,
      s = ((o = g({}, r = e)).audiences = (r.audiences || []).map(function (e) {
        return g({}, e);
      }), o.experiments = (r.experiments || []).map(function (e) {
        return g({}, e);
      }), o.featureFlags = (r.featureFlags || []).map(function (e) {
        return g({}, e);
      }), o.groups = (r.groups || []).map(function (e) {
        var t = g({}, e);
        return t.experiments = (e.experiments || []).map(function (e) {
          return g({}, e);
        }), t;
      }), o.rollouts = (r.rollouts || []).map(function (e) {
        var t = g({}, e);
        return t.experiments = (e.experiments || []).map(function (e) {
          return g({}, e);
        }), t;
      }), o.environmentKey = null !== (i = r.environmentKey) && void 0 !== i ? i : "", o.sdkKey = null !== (n = r.sdkKey) && void 0 !== n ? n : "", o);
    s.__datafileStr = null === t ? JSON.stringify(e) : t, (s.audiences || []).forEach(function (e) {
      e.conditions = JSON.parse(e.conditions);
    }), s.audiencesById = E(s.audiences, "id"), g(s.audiencesById, E(s.typedAudiences, "id")), s.attributeKeyMap = E(s.attributes, "key"), s.eventKeyMap = E(s.events, "key"), s.groupIdMap = E(s.groups, "id"), Object.keys(s.groupIdMap || {}).forEach(function (e) {
      (s.groupIdMap[e].experiments || []).forEach(function (t) {
        s.experiments.push(g(t, {
          groupId: e
        }));
      });
    }), s.rolloutIdMap = E(s.rollouts || [], "id"), v(s.rolloutIdMap || {}).forEach(function (e) {
      (e.experiments || []).forEach(function (e) {
        e.isRollout = !0, s.experiments.push(e), e.variationKeyMap = E(e.variations, "key");
      });
    });
    var a = new Set();
    Object.keys(s.audiencesById).map(function (e) {
      return He(s.audiencesById[e]);
    }).forEach(function (e) {
      e.forEach(function (e) {
        a.add(e);
      });
    });
    var u = Array.from(a),
      l = !1,
      c = "",
      p = "",
      d = "";
    return s.integrations && (s.integrationKeyMap = E(s.integrations, "key"), s.integrations.forEach(function (e) {
      if (!("key" in e)) throw new Error(N(H.MISSING_INTEGRATION_KEY, je));
      "odp" === e.key && (l = !0, p = p || e.publicKey || "", c = c || e.host || "", d = d || e.pixelUrl || "");
    })), s.odpIntegrationConfig = l ? {
      integrated: !0,
      odpConfig: new Ke(p, c, d, u)
    } : {
      integrated: !1
    }, s.experimentKeyMap = E(s.experiments, "key"), s.experimentIdMap = E(s.experiments, "id"), s.variationIdMap = {}, s.variationVariableUsageMap = {}, (s.experiments || []).forEach(function (e) {
      e.variationKeyMap = E(e.variations, "key"), g(s.variationIdMap, E(e.variations, "id")), v(e.variationKeyMap || {}).forEach(function (e) {
        e.variables && (s.variationVariableUsageMap[e.id] = E(e.variables, "id"));
      });
    }), s.experimentFeatureMap = {}, s.featureKeyMap = E(s.featureFlags || [], "key"), v(s.featureKeyMap || {}).forEach(function (e) {
      e.variables.forEach(function (e) {
        e.type === Z.STRING && e.subType === Z.JSON && (e.type = Z.JSON, delete e.subType);
      }), e.variableKeyMap = E(e.variables, "key"), (e.experimentIds || []).forEach(function (t) {
        s.experimentFeatureMap[t] ? s.experimentFeatureMap[t].push(e.id) : s.experimentFeatureMap[t] = [e.id];
      });
    }), s.flagRulesMap = {}, (s.featureFlags || []).forEach(function (e) {
      var t = [];
      e.experimentIds.forEach(function (e) {
        var r = s.experimentIdMap[e];
        r && t.push(r);
      });
      var r = s.rolloutIdMap[e.rolloutId];
      r && t.push.apply(t, r.experiments), s.flagRulesMap[e.key] = t;
    }), s.flagVariationsMap = {}, y(s.flagRulesMap || {}).forEach(function (e) {
      var t = e[0],
        r = e[1],
        i = [];
      r.forEach(function (e) {
        e.variations.forEach(function (e) {
          O(i, function (t) {
            return t.id === e.id;
          }) || i.push(e);
        });
      }), s.flagVariationsMap[t] = i;
    }), s;
  },
  He = function He(e) {
    return e.conditions ? ze(e.conditions) : [];
  },
  ze = function ze(e) {
    var t = [];
    return function (e) {
      return ["and", "or", "not"].includes(e);
    }(e) ? [] : (Array.isArray(e) ? e.forEach(function (e) {
      return t.push.apply(t, ze(e));
    }) : "qualified" === e.match && t.push(e.value), t);
  };
var Ye = function Ye(e, t) {
    var r = e.experimentIdMap[t];
    if (!r) throw new Error(N(H.INVALID_EXPERIMENT_ID, je, t));
    return r.layerId;
  },
  Xe = function Xe(e, t, r) {
    var i = e.attributeKeyMap[t],
      n = 0 === t.indexOf("$opt_");
    return i ? (n && r.log(q.WARNING, "Attribute %s unexpectedly has reserved prefix %s; using attribute ID instead of reserved attribute name.", t, "$opt_"), i.id) : n ? t : (r.log(q.DEBUG, H.UNRECOGNIZED_ATTRIBUTE, je, t), null);
  },
  Je = function Je(e, t) {
    var r = e.eventKeyMap[t];
    return r ? r.id : null;
  },
  We = function We(e, t) {
    var r = e.experimentKeyMap[t];
    if (!r) throw new Error(N(H.INVALID_EXPERIMENT_KEY, je, t));
    return r.status;
  },
  Ze = function Ze(e, t) {
    return e.variationIdMap.hasOwnProperty(t) ? e.variationIdMap[t].key : null;
  },
  Qe = function Qe(e, t) {
    if (e.experimentKeyMap.hasOwnProperty(t)) {
      var r = e.experimentKeyMap[t];
      if (r) return r;
    }
    throw new Error(N(H.EXPERIMENT_KEY_NOT_IN_DATAFILE, je, t));
  },
  $e = function $e(e, t) {
    var r = e.experimentIdMap[t];
    if (!r) throw new Error(N(H.INVALID_EXPERIMENT_ID, je, t));
    return r.trafficAllocation;
  },
  et = function et(e, t, r) {
    if (e.experimentIdMap.hasOwnProperty(t)) {
      var i = e.experimentIdMap[t];
      if (i) return i;
    }
    return r.log(q.ERROR, H.INVALID_EXPERIMENT_ID, je, t), null;
  },
  tt = function tt(e, t, r) {
    if (!e) return null;
    var i = O(e.flagVariationsMap[t], function (e) {
      return e.key === r;
    });
    return i || null;
  },
  rt = function rt(e, t, r) {
    if (e.featureKeyMap.hasOwnProperty(t)) {
      var i = e.featureKeyMap[t];
      if (i) return i;
    }
    return r.log(q.ERROR, H.FEATURE_NOT_IN_DATAFILE, je, t), null;
  },
  it = function it(e) {
    return e.__datafileStr;
  },
  nt = function nt(e) {
    var t;
    try {
      t = Ee(e.datafile);
    } catch (e) {
      return {
        configObj: null,
        error: e
      };
    }
    if (e.jsonSchemaValidator) try {
      e.jsonSchemaValidator.validate(t), e.logger.log(q.INFO, z.VALID_DATAFILE, je);
    } catch (e) {
      return {
        configObj: null,
        error: e
      };
    } else e.logger.log(q.INFO, z.SKIPPING_JSON_VALIDATION, je);
    var r = [t];
    return "string" == typeof e.datafile && r.push(e.datafile), {
      configObj: qe.apply(void 0, r),
      error: null
    };
  },
  ot = function ot(e) {
    return !!e.sendFlagDecisions;
  };
function st(e, t, r, i) {
  var n = {
    sdkKey: e
  };
  if ((void 0 === i || "object" == typeof i && null !== i) && A.assign(n, i), r) {
    var o = nt({
        datafile: r,
        jsonSchemaValidator: void 0,
        logger: t
      }),
      s = o.configObj,
      a = o.error;
    a && t.error(a), s && (n.datafile = it(s));
  }
  return new Be(n);
}
var at = function () {
    function e(e, t) {
      void 0 === t && (t = 6e4), this.logger = e, this.timeout = t;
    }
    return e.prototype.makeRequest = function (e, t, r, i) {
      var n = this,
        o = new XMLHttpRequest();
      return {
        responsePromise: new Promise(function (s, a) {
          o.open(r, e, !0), n.setHeadersInXhr(t, o), o.onreadystatechange = function () {
            if (o.readyState === XMLHttpRequest.DONE) {
              if (0 === o.status) return void a(new Error("Request error"));
              var e = n.parseHeadersFromXhr(o),
                t = {
                  statusCode: o.status,
                  body: o.responseText,
                  headers: e
                };
              s(t);
            }
          }, o.timeout = n.timeout, o.ontimeout = function () {
            n.logger.log(exports.LogLevel.WARNING, "Request timed out");
          }, o.send(i);
        }),
        abort: function abort() {
          o.abort();
        }
      };
    }, e.prototype.setHeadersInXhr = function (e, t) {
      Object.keys(e).forEach(function (r) {
        var i = e[r];
        "string" == typeof i && t.setRequestHeader(r, i);
      });
    }, e.prototype.parseHeadersFromXhr = function (e) {
      var t = this,
        r = e.getAllResponseHeaders();
      if (null === r) return {};
      var i = r.split("\r\n"),
        n = {};
      return i.forEach(function (e) {
        try {
          var r = e.indexOf(": ");
          if (r > -1) {
            var i = e.slice(0, r),
              o = e.slice(r + 2);
            i && o && (n[i] = o);
          }
        } catch (r) {
          t.logger.log(exports.LogLevel.WARNING, "Unable to parse & skipped header item '".concat(e, "'"));
        }
      }), n;
    }, e;
  }(),
  ut = function ut(e) {
    var t = e.browserCallback,
      r = e.nonBrowserCallback;
    return "undefined" != typeof window ? t(null === window || void 0 === window ? void 0 : window.localStorage) : r();
  },
  lt = function () {
    function e() {
      this.logger = M();
    }
    return e.prototype.contains = function (e) {
      return u(this, void 0, void 0, function () {
        var t = this;
        return l(this, function (r) {
          return [2, ut({
            browserCallback: function browserCallback(t) {
              return null !== (null == t ? void 0 : t.getItem(e));
            },
            nonBrowserCallback: function nonBrowserCallback() {
              return t.logger.error(H.LOCAL_STORAGE_DOES_NOT_EXIST), !1;
            }
          })];
        });
      });
    }, e.prototype.get = function (e) {
      return u(this, void 0, void 0, function () {
        var t = this;
        return l(this, function (r) {
          return [2, ut({
            browserCallback: function browserCallback(t) {
              return (null == t ? void 0 : t.getItem(e)) || void 0;
            },
            nonBrowserCallback: function nonBrowserCallback() {
              t.logger.error(H.LOCAL_STORAGE_DOES_NOT_EXIST);
            }
          })];
        });
      });
    }, e.prototype.remove = function (e) {
      return u(this, void 0, void 0, function () {
        var t = this;
        return l(this, function (r) {
          switch (r.label) {
            case 0:
              return [4, this.contains(e)];
            case 1:
              return r.sent() ? (ut({
                browserCallback: function browserCallback(t) {
                  null == t || t.removeItem(e);
                },
                nonBrowserCallback: function nonBrowserCallback() {
                  t.logger.error(H.LOCAL_STORAGE_DOES_NOT_EXIST);
                }
              }), [2, !0]) : [2, !1];
          }
        });
      });
    }, e.prototype.set = function (e, t) {
      return u(this, void 0, void 0, function () {
        var r = this;
        return l(this, function (i) {
          return [2, ut({
            browserCallback: function browserCallback(r) {
              null == r || r.setItem(e, t);
            },
            nonBrowserCallback: function nonBrowserCallback() {
              r.logger.error(H.LOCAL_STORAGE_DOES_NOT_EXIST);
            }
          })];
        });
      });
    }, e;
  }(),
  ct = function () {
    function e(e) {
      void 0 === e && (e = null), this._value = e, this._time = Date.now();
    }
    return Object.defineProperty(e.prototype, "value", {
      get: function get() {
        return this._value;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "time", {
      get: function get() {
        return this._time;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.is_stale = function (e) {
      return !(e <= 0) && Date.now() - this._time >= e;
    }, e;
  }(),
  pt = function () {
    function e(e) {
      var t = e.maxSize,
        r = e.timeout;
      this._map = new Map();
      var i = M();
      i.debug("Provisioning cache with maxSize of ".concat(t)), i.debug("Provisioning cache with timeout of ".concat(r)), this._maxSize = t, this._timeout = r;
    }
    return Object.defineProperty(e.prototype, "map", {
      get: function get() {
        return this._map;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "maxSize", {
      get: function get() {
        return this._maxSize;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "timeout", {
      get: function get() {
        return this._timeout;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.lookup = function (e) {
      if (this._maxSize <= 0) return null;
      var t = this._map.get(e);
      return t ? t.is_stale(this._timeout) ? (this._map.delete(e), null) : (this._map.delete(e), this._map.set(e, t), t.value) : null;
    }, e.prototype.save = function (e) {
      var t = e.key,
        r = e.value;
      if (!(this._maxSize <= 0) && (this._map.get(t) && this._map.delete(t), this._map.set(t, new ct(r)), this._map.size > this._maxSize)) {
        var i = this._map.keys().next().value;
        this._map.delete(i);
      }
    }, e.prototype.reset = function () {
      this._maxSize <= 0 || this._map.clear();
    }, e.prototype.peek = function (e) {
      var t;
      if (this._maxSize <= 0) return null;
      var r = this._map.get(e);
      return null !== (t = null == r ? void 0 : r.value) && void 0 !== t ? t : null;
    }, e;
  }(),
  dt = 100,
  ft = 600,
  gt = function (e) {
    function t(t) {
      var r, i;
      return e.call(this, {
        maxSize: null !== (r = null == t ? void 0 : t.maxSize) && void 0 !== r ? r : dt,
        timeout: null !== (i = null == t ? void 0 : t.timeout) && void 0 !== i ? i : 1e3 * ft
      }) || this;
    }
    return s(t, e), t;
  }(pt),
  Et = 1e4,
  ht = 600,
  It = (function (e) {
    function t(t) {
      var r, i;
      return e.call(this, {
        maxSize: null !== (r = null == t ? void 0 : t.maxSize) && void 0 !== r ? r : Et,
        timeout: null !== (i = null == t ? void 0 : t.timeout) && void 0 !== i ? i : 1e3 * ht
      }) || this;
    }
    s(t, e);
  }(pt), function () {
    function e() {
      this._keyForVuid = "optimizely-vuid", this._vuid = "";
    }
    return Object.defineProperty(e.prototype, "vuid", {
      get: function get() {
        return this._vuid;
      },
      enumerable: !1,
      configurable: !0
    }), e.instance = function (t) {
      return u(this, void 0, void 0, function () {
        return l(this, function (r) {
          switch (r.label) {
            case 0:
              return this._instance || (this._instance = new e()), this._instance._vuid ? [3, 2] : [4, this._instance.load(t)];
            case 1:
              r.sent(), r.label = 2;
            case 2:
              return [2, this._instance];
          }
        });
      });
    }, e.prototype.load = function (t) {
      return u(this, void 0, void 0, function () {
        var r;
        return l(this, function (i) {
          switch (i.label) {
            case 0:
              return [4, t.get(this._keyForVuid)];
            case 1:
              return (r = i.sent()) && e.isVuid(r) ? (this._vuid = r, [3, 4]) : [3, 2];
            case 2:
              return this._vuid = this.makeVuid(), [4, this.save(this._vuid, t)];
            case 3:
              i.sent(), i.label = 4;
            case 4:
              return [2, this._vuid];
          }
        });
      });
    }, e.prototype.makeVuid = function () {
      var t = h().replace(/-/g, "").toLowerCase(),
        r = "".concat(e.vuid_prefix).concat(t);
      return r.length <= 32 ? r : r.substring(0, 32);
    }, e.prototype.save = function (e, t) {
      return u(this, void 0, void 0, function () {
        return l(this, function (r) {
          switch (r.label) {
            case 0:
              return [4, t.set(this._keyForVuid, e)];
            case 1:
              return r.sent(), [2];
          }
        });
      });
    }, e._reset = function () {
      this._instance._vuid = "";
    }, e.vuid_prefix = "vuid_", e.isVuid = function (t) {
      return (null == t ? void 0 : t.startsWith(e.vuid_prefix)) || !1;
    }, e;
  }());
function _t(e) {
  var t = ["string", "number", "boolean"],
    r = !1;
  return e.forEach(function (e) {
    t.includes(typeof e) || null === e || (r = !0);
  }), r;
}
var vt,
  yt = function yt(e, t, r, i) {
    this.type = e, this.action = t, this.identifiers = null != r ? r : new Map(), this.data = null != i ? i : new Map();
  },
  Ot = function Ot() {};
!function (e) {
  e[e.Running = 0] = "Running", e[e.Stopped = 1] = "Stopped";
}(vt || (vt = {}));
var Rt,
  Nt = function () {
    function e(e) {
      var t,
        r,
        i,
        n = e.odpIntegrationConfig,
        o = e.segmentManager,
        s = e.eventManager,
        a = e.logger,
        u = this;
      this.ready = !1, this.status = vt.Stopped, this.segmentManager = o, this.eventManager = s, this.logger = a, this.configPromise = (t = Ot, r = Ot, {
        promise: i = new Promise(function (e, i) {
          t = e, r = i;
        }),
        resolve: t,
        reject: r,
        then: i.then.bind(i)
      });
      var l = [this.configPromise];
      this.isVuidEnabled() && l.push(this.initializeVuid()), this.initPromise = Promise.all(l), this.onReady().then(function () {
        u.ready = !0, u.isVuidEnabled() && u.status === vt.Running && u.registerVuid();
      }), n && this.updateSettings(n);
    }
    return e.prototype.getStatus = function () {
      return this.status;
    }, e.prototype.start = function () {
      return u(this, void 0, void 0, function () {
        return l(this, function (e) {
          return this.status === vt.Running ? [2] : this.odpIntegrationConfig ? this.odpIntegrationConfig.integrated ? (this.status = vt.Running, this.segmentManager.updateSettings(this.odpIntegrationConfig.odpConfig), this.eventManager.updateSettings(this.odpIntegrationConfig.odpConfig), this.eventManager.start(), [2, Promise.resolve()]) : [2, Promise.reject(new Error("start() called when ODP is not integrated"))] : [2, Promise.reject(new Error("cannot start without ODP config"))];
        });
      });
    }, e.prototype.stop = function () {
      return u(this, void 0, void 0, function () {
        return l(this, function (e) {
          switch (e.label) {
            case 0:
              return this.status === vt.Stopped ? [2] : (this.status = vt.Stopped, [4, this.eventManager.stop()]);
            case 1:
              return e.sent(), [2];
          }
        });
      });
    }, e.prototype.onReady = function () {
      return this.initPromise;
    }, e.prototype.isReady = function () {
      return this.ready;
    }, e.prototype.updateSettings = function (e) {
      return this.configPromise.resolve(), !(this.odpIntegrationConfig && (t = this.odpIntegrationConfig, r = e, !(t.integrated !== r.integrated || t.integrated && r.integrated && !t.odpConfig.equals(r.odpConfig)))) && (this.odpIntegrationConfig = e, e.integrated ? this.status === vt.Running ? (this.segmentManager.updateSettings(e.odpConfig), this.eventManager.updateSettings(e.odpConfig)) : this.start() : this.stop(), !0);
      var t, r;
    }, e.prototype.fetchQualifiedSegments = function (e, t) {
      return void 0 === t && (t = []), u(this, void 0, void 0, function () {
        return l(this, function (r) {
          return this.odpIntegrationConfig ? this.odpIntegrationConfig.integrated ? It.isVuid(e) ? [2, this.segmentManager.fetchQualifiedSegments(ee.VUID, e, t)] : [2, this.segmentManager.fetchQualifiedSegments(ee.FS_USER_ID, e, t)] : (this.logger.log(exports.LogLevel.ERROR, H.ODP_NOT_INTEGRATED), [2, null]) : (this.logger.log(exports.LogLevel.ERROR, H.ODP_CONFIG_NOT_AVAILABLE), [2, null]);
        });
      });
    }, e.prototype.identifyUser = function (e, t) {
      this.odpIntegrationConfig ? this.odpIntegrationConfig.integrated ? e && It.isVuid(e) ? this.eventManager.identifyUser(void 0, e) : this.eventManager.identifyUser(e, t) : this.logger.log(exports.LogLevel.INFO, H.ODP_NOT_INTEGRATED) : this.logger.log(exports.LogLevel.ERROR, H.ODP_CONFIG_NOT_AVAILABLE);
    }, e.prototype.sendEvent = function (e) {
      var t = e.type,
        r = e.action,
        i = e.identifiers,
        n = e.data,
        o = t;
      if ("string" == typeof o && "" !== o || (o = "fullstack"), this.odpIntegrationConfig) {
        if (this.odpIntegrationConfig.integrated) {
          if (_t(n)) throw new Error(H.ODP_INVALID_DATA);
          if ("string" != typeof r || "" === r) throw new Error("ODP action is not valid (cannot be empty).");
          this.eventManager.sendEvent(new yt(o, r, i, n));
        } else this.logger.log(exports.LogLevel.ERROR, H.ODP_NOT_INTEGRATED);
      } else this.logger.log(exports.LogLevel.ERROR, H.ODP_CONFIG_NOT_AVAILABLE);
    }, e.prototype.initializeVuid = function () {
      return Promise.resolve();
    }, e.prototype.registerVuid = function () {
      if (this.odpIntegrationConfig) {
        if (this.odpIntegrationConfig.integrated) {
          var e = this.getVuid();
          if (e) try {
            this.eventManager.registerVuid(e);
          } catch (e) {
            this.logger.log(exports.LogLevel.ERROR, H.ODP_VUID_REGISTRATION_FAILED);
          }
        } else this.logger.log(exports.LogLevel.INFO, H.ODP_NOT_INTEGRATED);
      } else this.logger.log(exports.LogLevel.ERROR, H.ODP_CONFIG_NOT_AVAILABLE);
    }, e;
  }(),
  Tt = function () {
    function e(e, t) {
      this.requestHandler = e, this.logger = t;
    }
    return e.prototype.getLogger = function () {
      return this.logger;
    }, e.prototype.sendEvents = function (e, t) {
      var r;
      return u(this, void 0, void 0, function () {
        var i, n, o, s, a, u, c, p, d, f;
        return l(this, function (l) {
          switch (l.label) {
            case 0:
              if (i = !1, 0 === t.length) return this.logger.log(exports.LogLevel.ERROR, "".concat("ODP event send failed", " (no events)")), [2, i];
              if (!this.shouldSendEvents(t)) return [2, i];
              n = this.generateRequestData(e, t), o = n.method, s = n.endpoint, a = n.headers, u = n.data, c = 0, l.label = 1;
            case 1:
              return l.trys.push([1, 3,, 4]), [4, this.requestHandler.makeRequest(s, a, o, u).responsePromise];
            case 2:
              return p = l.sent(), c = null !== (r = p.statusCode) && void 0 !== r ? r : c, [3, 4];
            case 3:
              return d = l.sent(), f = "network error", d instanceof Error && (f = d.message), this.logger.log(exports.LogLevel.ERROR, "".concat("ODP event send failed", " (").concat(f, ")")), i = !0, [3, 4];
            case 4:
              return c >= 400 && this.logger.log(exports.LogLevel.ERROR, "".concat("ODP event send failed", " (").concat(c, ")")), c >= 500 && (i = !0), [2, i];
          }
        });
      });
    }, e;
  }(),
  mt = function (e) {
    function t() {
      return null !== e && e.apply(this, arguments) || this;
    }
    return s(t, e), t.prototype.shouldSendEvents = function (e) {
      return e.length <= 1 || (this.getLogger().log(exports.LogLevel.ERROR, "".concat("ODP event send failed", " (browser only supports batch size 1)")), !1);
    }, t.prototype.getPixelApiEndpoint = function (e) {
      var t = e.pixelUrl;
      return new URL("v2/zaius.gif", t).href;
    }, t.prototype.generateRequestData = function (e, t) {
      var r = this.getPixelApiEndpoint(e),
        i = e.apiKey,
        n = t[0],
        o = new URL(r);
      return n.identifiers.forEach(function (e, t) {
        o.searchParams.append(t, e);
      }), n.data.forEach(function (e, t) {
        o.searchParams.append(t, e);
      }), o.searchParams.append("tracker_id", i), o.searchParams.append("event_type", n.type), o.searchParams.append("vdl_action", n.action), {
        method: "GET",
        endpoint: o.toString(),
        headers: {},
        data: ""
      };
    }, t;
  }(Tt),
  At = function At(e) {
    "function" == typeof queueMicrotask ? queueMicrotask(e) : setTimeout(e);
  };
!function (e) {
  e[e.Stopped = 0] = "Stopped", e[e.Running = 1] = "Running";
}(Rt || (Rt = {}));
var Dt = function () {
    function e(e) {
      var t = e.odpConfig,
        r = e.apiManager,
        i = e.logger,
        n = e.clientEngine,
        o = e.clientVersion,
        s = e.queueSize,
        a = e.batchSize,
        u = e.flushInterval,
        l = e.userAgentParser,
        c = e.retries;
      if (this.status = Rt.Stopped, this.queue = new Array(), this.apiManager = r, this.logger = i, this.clientEngine = n, this.clientVersion = o, this.initParams(a, s, u), this.status = Rt.Stopped, this.userAgentParser = l, this.retries = c || 3, l) {
        var p = l.parseUserAgentInfo(),
          d = p.os,
          f = p.device,
          g = {
            os: d.name,
            os_version: d.version,
            device_type: f.type,
            model: f.model
          };
        this.userAgentData = new Map(Object.entries(g).filter(function (e) {
          e[0];
          var t = e[1];
          return null != t && null != t;
        }));
      }
      t && this.updateSettings(t);
    }
    return e.prototype.updateSettings = function (e) {
      this.odpConfig && this.odpConfig.equals(e) || (this.flush(), this.odpConfig = e);
    }, e.prototype.flush = function () {
      this.processQueue(!0);
    }, e.prototype.start = function () {
      this.odpConfig ? (this.status = Rt.Running, this.batchSize > 1 && this.setNewTimeout()) : this.logger.log(exports.LogLevel.ERROR, H.ODP_CONFIG_NOT_AVAILABLE);
    }, e.prototype.stop = function () {
      return u(this, void 0, void 0, function () {
        return l(this, function (e) {
          return this.logger.log(exports.LogLevel.DEBUG, "Stop requested."), this.flush(), this.clearCurrentTimeout(), this.status = Rt.Stopped, this.logger.log(exports.LogLevel.DEBUG, "Stopped. Queue Count: %s", this.queue.length), [2];
        });
      });
    }, e.prototype.registerVuid = function (e) {
      var t = new Map();
      t.set(ee.VUID, e);
      var r = new yt("fullstack", te.INITIALIZED, t);
      this.sendEvent(r);
    }, e.prototype.identifyUser = function (e, t) {
      var r = new Map();
      if (e || t) {
        t && r.set(ee.VUID, t), e && r.set(ee.FS_USER_ID, e);
        var i = new yt("fullstack", te.IDENTIFIED, r);
        this.sendEvent(i);
      } else this.logger.log(exports.LogLevel.ERROR, H.ODP_SEND_EVENT_FAILED_UID_MISSING);
    }, e.prototype.sendEvent = function (e) {
      _t(e.data) ? this.logger.log(exports.LogLevel.ERROR, "Event data found to be invalid.") : (e.data = this.augmentCommonData(e.data), this.enqueue(e));
    }, e.prototype.enqueue = function (e) {
      this.status !== Rt.Stopped ? this.hasNecessaryIdentifiers(e) ? this.queue.length >= this.queueSize ? this.logger.log(exports.LogLevel.WARNING, "Failed to Process ODP Event. Event Queue full. queueSize = %s.", this.queue.length) : (this.queue.push(e), this.processQueue()) : this.logger.log(exports.LogLevel.ERROR, "ODP events should have at least one key-value pair in identifiers.") : this.logger.log(exports.LogLevel.WARNING, "Failed to Process ODP Event. ODPEventManager is not running.");
    }, e.prototype.processQueue = function (e) {
      if (void 0 === e && (e = !1), this.status === Rt.Running) {
        if (e) for (this.clearCurrentTimeout(); this.queueContainsItems();) this.makeAndSend1Batch();else if (this.queueHasBatches()) for (this.clearCurrentTimeout(); this.queueHasBatches();) this.makeAndSend1Batch();
        this.batchSize > 1 && this.setNewTimeout();
      }
    }, e.prototype.clearCurrentTimeout = function () {
      clearTimeout(this.timeoutId), this.timeoutId = void 0;
    }, e.prototype.setNewTimeout = function () {
      var e = this;
      void 0 === this.timeoutId && (this.timeoutId = setTimeout(function () {
        return e.processQueue(!0);
      }, this.flushInterval));
    }, e.prototype.makeAndSend1Batch = function () {
      var e = this;
      if (this.odpConfig) {
        var t = this.queue.splice(0, this.batchSize),
          r = this.odpConfig;
        t.length > 0 && At(function () {
          return u(e, void 0, void 0, function () {
            var e, i;
            return l(this, function (n) {
              switch (n.label) {
                case 0:
                  i = 0, n.label = 1;
                case 1:
                  return [4, this.apiManager.sendEvents(r, t)];
                case 2:
                  e = n.sent(), i += 1, n.label = 3;
                case 3:
                  if (e && i < this.retries) return [3, 1];
                  n.label = 4;
                case 4:
                  return [2];
              }
            });
          });
        });
      }
    }, e.prototype.queueHasBatches = function () {
      return this.queueContainsItems() && this.queue.length % this.batchSize == 0;
    }, e.prototype.queueContainsItems = function () {
      return this.queue.length > 0;
    }, e.prototype.augmentCommonData = function (e) {
      var t = new Map(this.userAgentData);
      return t.set("idempotence_id", h()), t.set("data_source_type", "sdk"), t.set("data_source", this.clientEngine), t.set("data_source_version", this.clientVersion), e.forEach(function (e, r) {
        return t.set(r, e);
      }), t;
    }, e.prototype.getLogger = function () {
      return this.logger;
    }, e.prototype.getQueue = function () {
      return this.queue;
    }, e;
  }(),
  St = function (e) {
    function t() {
      var t = null !== e && e.apply(this, arguments) || this;
      return t.hasNecessaryIdentifiers = function (e) {
        return e.identifiers.size >= 0;
      }, t;
    }
    return s(t, e), t.prototype.initParams = function (e, t, r) {
      this.queueSize = t || 100, this.batchSize = 1, this.flushInterval = 0, void 0 !== e && 1 !== e && this.getLogger().log(exports.LogLevel.WARNING, "ODP event batch size must be 1 in the browser."), void 0 !== r && 0 !== r && this.getLogger().log(exports.LogLevel.WARNING, "ODP event flush interval must be 0 in the browser.");
    }, t.prototype.discardEventsIfNeeded = function () {
      this.getLogger().log(exports.LogLevel.DEBUG, "ODPConfig not ready. Leaving events in queue.");
    }, t;
  }(Dt),
  Lt = function () {
    function e(e, t, r, i) {
      this.odpConfig = i, this._segmentsCache = e, this.odpSegmentApiManager = t, this.logger = r || M("OdpSegmentManager");
    }
    return Object.defineProperty(e.prototype, "segmentsCache", {
      get: function get() {
        return this._segmentsCache;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.fetchQualifiedSegments = function (e, t, r) {
      return u(this, void 0, void 0, function () {
        var i, n, o, s, a, u;
        return l(this, function (l) {
          switch (l.label) {
            case 0:
              if (!this.odpConfig) return this.logger.log(exports.LogLevel.WARNING, H.ODP_CONFIG_NOT_AVAILABLE), [2, null];
              if (!(i = this.odpConfig.segmentsToCheck) || i.length <= 0) return this.logger.log(exports.LogLevel.DEBUG, "No segments are used in the project. Returning an empty list."), [2, []];
              if (n = this.makeCacheKey(e, t), o = r.includes(exports.OptimizelySegmentOption.IGNORE_CACHE), (s = r.includes(exports.OptimizelySegmentOption.RESET_CACHE)) && this.reset(), !o && !s) {
                if (a = this._segmentsCache.lookup(n)) return this.logger.log(exports.LogLevel.DEBUG, 'ODP cache hit. Returning segments from cache "%s".', n), [2, a];
                this.logger.log(exports.LogLevel.DEBUG, "ODP cache miss.");
              }
              return this.logger.log(exports.LogLevel.DEBUG, "Making a call to ODP server."), [4, this.odpSegmentApiManager.fetchSegments(this.odpConfig.apiKey, this.odpConfig.apiHost, e, t, i)];
            case 1:
              return (u = l.sent()) && !o && this._segmentsCache.save({
                key: n,
                value: u
              }), [2, u];
          }
        });
      });
    }, e.prototype.reset = function () {
      this._segmentsCache.reset();
    }, e.prototype.makeCacheKey = function (e, t) {
      return "".concat(e, "-$-").concat(t);
    }, e.prototype.updateSettings = function (e) {
      this.odpConfig = e, this.reset();
    }, e;
  }(),
  Ut = {
    $schema: "http://json-schema.org/draft-04/schema#",
    title: "Project Config JSON Schema",
    type: "object",
    properties: {
      projectId: {
        type: "string",
        required: !0
      },
      accountId: {
        type: "string",
        required: !0
      },
      groups: {
        type: "array",
        items: {
          type: "object",
          properties: {
            id: {
              type: "string",
              required: !0
            },
            policy: {
              type: "string",
              required: !0
            },
            trafficAllocation: {
              type: "array",
              items: {
                type: "object",
                properties: {
                  entityId: {
                    type: "string",
                    required: !0
                  },
                  endOfRange: {
                    type: "integer",
                    required: !0
                  }
                }
              },
              required: !0
            },
            experiments: {
              type: "array",
              items: {
                type: "object",
                properties: {
                  id: {
                    type: "string",
                    required: !0
                  },
                  key: {
                    type: "string",
                    required: !0
                  },
                  status: {
                    type: "string",
                    required: !0
                  },
                  layerId: {
                    type: "string",
                    required: !0
                  },
                  variations: {
                    type: "array",
                    items: {
                      type: "object",
                      properties: {
                        id: {
                          type: "string",
                          required: !0
                        },
                        key: {
                          type: "string",
                          required: !0
                        }
                      }
                    },
                    required: !0
                  },
                  trafficAllocation: {
                    type: "array",
                    items: {
                      type: "object",
                      properties: {
                        entityId: {
                          type: "string",
                          required: !0
                        },
                        endOfRange: {
                          type: "integer",
                          required: !0
                        }
                      }
                    },
                    required: !0
                  },
                  audienceIds: {
                    type: "array",
                    items: {
                      type: "string"
                    },
                    required: !0
                  },
                  forcedVariations: {
                    type: "object",
                    required: !0
                  }
                }
              },
              required: !0
            }
          }
        },
        required: !0
      },
      experiments: {
        type: "array",
        items: {
          type: "object",
          properties: {
            id: {
              type: "string",
              required: !0
            },
            key: {
              type: "string",
              required: !0
            },
            status: {
              type: "string",
              required: !0
            },
            layerId: {
              type: "string",
              required: !0
            },
            variations: {
              type: "array",
              items: {
                type: "object",
                properties: {
                  id: {
                    type: "string",
                    required: !0
                  },
                  key: {
                    type: "string",
                    required: !0
                  }
                }
              },
              required: !0
            },
            trafficAllocation: {
              type: "array",
              items: {
                type: "object",
                properties: {
                  entityId: {
                    type: "string",
                    required: !0
                  },
                  endOfRange: {
                    type: "integer",
                    required: !0
                  }
                }
              },
              required: !0
            },
            audienceIds: {
              type: "array",
              items: {
                type: "string"
              },
              required: !0
            },
            forcedVariations: {
              type: "object",
              required: !0
            }
          }
        },
        required: !0
      },
      events: {
        type: "array",
        items: {
          type: "object",
          properties: {
            key: {
              type: "string",
              required: !0
            },
            experimentIds: {
              type: "array",
              items: {
                type: "string",
                required: !0
              }
            },
            id: {
              type: "string",
              required: !0
            }
          }
        },
        required: !0
      },
      audiences: {
        type: "array",
        items: {
          type: "object",
          properties: {
            id: {
              type: "string",
              required: !0
            },
            name: {
              type: "string",
              required: !0
            },
            conditions: {
              type: "string",
              required: !0
            }
          }
        },
        required: !0
      },
      attributes: {
        type: "array",
        items: {
          type: "object",
          properties: {
            id: {
              type: "string",
              required: !0
            },
            key: {
              type: "string",
              required: !0
            }
          }
        },
        required: !0
      },
      version: {
        type: "string",
        required: !0
      },
      revision: {
        type: "string",
        required: !0
      },
      integrations: {
        type: "array",
        items: {
          type: "object",
          properties: {
            key: {
              type: "string",
              required: !0
            },
            host: {
              type: "string"
            },
            publicKey: {
              type: "string"
            },
            pixelUrl: {
              type: "string"
            }
          }
        }
      }
    }
  };
var Ct = {
    $schema: "https://json-schema.org/draft/2019-09/schema",
    $id: "https://example.com/example.json",
    title: "ODP Response Schema",
    type: "object",
    required: ["data"],
    properties: {
      data: {
        title: "The data Schema",
        type: "object",
        required: ["customer"],
        properties: {
          customer: {
            title: "The customer Schema",
            type: "object",
            required: [],
            properties: {
              audiences: {
                title: "The audiences Schema",
                type: "object",
                required: ["edges"],
                properties: {
                  edges: {
                    title: "The edges Schema",
                    type: "array",
                    items: {
                      title: "A Schema",
                      type: "object",
                      required: ["node"],
                      properties: {
                        node: {
                          title: "The node Schema",
                          type: "object",
                          required: ["name", "state"],
                          properties: {
                            name: {
                              title: "The name Schema",
                              type: "string",
                              examples: ["has_email", "has_email_opted_in"]
                            },
                            state: {
                              title: "The state Schema",
                              type: "string",
                              examples: ["qualified"]
                            }
                          },
                          examples: []
                        }
                      },
                      examples: []
                    },
                    examples: []
                  }
                },
                examples: []
              }
            },
            examples: []
          }
        },
        examples: []
      },
      errors: {
        title: "The errors Schema",
        type: "array",
        default: [],
        items: {
          title: "A Schema",
          type: "object",
          required: ["message", "locations", "extensions"],
          properties: {
            message: {
              title: "The message Schema",
              type: "string",
              examples: ["Exception while fetching data (/customer) : java.lang.RuntimeException: could not resolve _fs_user_id = asdsdaddddd"]
            },
            locations: {
              title: "The locations Schema",
              type: "array",
              items: {
                title: "A Schema",
                type: "object",
                required: ["line", "column"],
                properties: {
                  line: {
                    title: "The line Schema",
                    type: "integer",
                    examples: [2]
                  },
                  column: {
                    title: "The column Schema",
                    type: "integer",
                    examples: [3]
                  }
                },
                examples: []
              },
              examples: []
            },
            path: {
              title: "The path Schema",
              type: "array",
              items: {
                title: "A Schema",
                type: "string",
                examples: ["customer"]
              },
              examples: []
            },
            extensions: {
              title: "The extensions Schema",
              type: "object",
              required: ["classification"],
              properties: {
                classification: {
                  title: "The classification Schema",
                  type: "string",
                  examples: ["InvalidIdentifierException"]
                }
              },
              examples: []
            }
          },
          examples: []
        },
        examples: []
      }
    },
    examples: []
  },
  Pt = [],
  bt = function () {
    function e(e, t) {
      this.toGraphQLJson = function (e, t, r) {
        return c(c(['{"query" : "query {customer', "(".concat(e, ' : \\"').concat(t, '\\") '), "{audiences", "(subset: ["], (null == r ? void 0 : r.map(function (e, t) {
          return '\\"'.concat(e, '\\"').concat(t < r.length - 1 ? "," : "");
        })) || "", !0), [']) {edges {node {name state}}}}}"}'], !1).join("");
      }, this.requestHandler = e, this.logger = t;
    }
    return e.prototype.fetchSegments = function (e, t, r, i, n) {
      var o, s, a, c;
      return u(this, void 0, void 0, function () {
        var u, p, d, f, g, E, h, I;
        return l(this, function (l) {
          switch (l.label) {
            case 0:
              return e && t ? 0 === (null == n ? void 0 : n.length) ? [2, Pt] : (u = "".concat(t, "/v3/graphql"), p = this.toGraphQLJson(r, i, n), [4, this.querySegments(e, u, r, i, p)]) : (this.logger.log(exports.LogLevel.ERROR, "".concat("Audience segments fetch failed", " (Parameters apiKey or apiHost invalid)")), [2, null]);
            case 1:
              return (d = l.sent()) ? (f = this.parseSegmentsResponseJson(d)) ? (null === (o = f.errors) || void 0 === o ? void 0 : o.length) > 0 ? (g = f.errors[0].extensions, E = g.code, h = g.classification, "INVALID_IDENTIFIER_EXCEPTION" == E ? this.logger.log(exports.LogLevel.ERROR, "".concat("Audience segments fetch failed", " (invalid identifier)")) : this.logger.log(exports.LogLevel.ERROR, "".concat("Audience segments fetch failed", " (").concat(h, ")")), [2, null]) : (I = null === (c = null === (a = null === (s = null == f ? void 0 : f.data) || void 0 === s ? void 0 : s.customer) || void 0 === a ? void 0 : a.audiences) || void 0 === c ? void 0 : c.edges) ? [2, I.filter(function (e) {
                return "qualified" == e.node.state;
              }).map(function (e) {
                return e.node.name;
              })] : (this.logger.log(exports.LogLevel.ERROR, "".concat("Audience segments fetch failed", " (decode error)")), [2, null]) : (this.logger.log(exports.LogLevel.ERROR, "".concat("Audience segments fetch failed", " (decode error)")), [2, null]) : (this.logger.log(exports.LogLevel.ERROR, "".concat("Audience segments fetch failed", " (network error)")), [2, null]);
          }
        });
      });
    }, e.prototype.querySegments = function (e, t, r, i, n) {
      return u(this, void 0, void 0, function () {
        var r, i, o, s;
        return l(this, function (a) {
          switch (a.label) {
            case 0:
              r = "POST", i = t, o = {
                "Content-Type": "application/json",
                "x-api-key": e
              }, a.label = 1;
            case 1:
              return a.trys.push([1, 3,, 4]), [4, this.requestHandler.makeRequest(i, o, r, n).responsePromise];
            case 2:
              return s = a.sent(), [3, 4];
            case 3:
              return a.sent(), [2, null];
            case 4:
              return [2, s.body];
          }
        });
      });
    }, e.prototype.parseSegmentsResponseJson = function (e) {
      var t = {};
      try {
        t = JSON.parse(e);
      } catch (e) {
        return null;
      }
      return function (e, t, i) {
        void 0 === t && (t = Ut), void 0 === i && (i = !0);
        var n = "".concat("JSON_SCHEMA_VALIDATOR", " (").concat(t.title, ")");
        if ("object" != typeof e || null === e) throw new Error(N(H.NO_JSON_PROVIDED, n));
        var o = r.validate(e, t);
        if (o.valid) return !0;
        if (!i) return !1;
        if (Array.isArray(o.errors)) throw new Error(N(H.INVALID_DATAFILE, n, o.errors[0].property, o.errors[0].message));
        throw new Error(N(H.INVALID_JSON, n));
      }(t, Ct, !1) ? t : null;
    }, e;
  }(),
  Vt = function (e) {
    function t(t) {
      return e.call(this, t) || this;
    }
    return s(t, e), t.createInstance = function (e) {
      var r = e.logger,
        i = e.odpOptions,
        n = e.odpIntegrationConfig,
        o = e.clientEngine,
        s = e.clientVersion;
      r = r || M(), o = o || "javascript-sdk", s = s || "5.3.5";
      var a,
        u,
        l,
        c = void 0;
      return (null == n ? void 0 : n.integrated) && (c = n.odpConfig), a = (null == i ? void 0 : i.segmentsRequestHandler) ? i.segmentsRequestHandler : new at(r, (null == i ? void 0 : i.segmentsApiTimeout) || 1e4), u = (null == i ? void 0 : i.segmentManager) ? i.segmentManager : new Lt((null == i ? void 0 : i.segmentsCache) || new gt({
        maxSize: null == i ? void 0 : i.segmentsCacheSize,
        timeout: null == i ? void 0 : i.segmentsCacheTimeout
      }), new bt(a, r), r, c), l = (null == i ? void 0 : i.eventRequestHandler) ? i.eventRequestHandler : new at(r, (null == i ? void 0 : i.eventApiTimeout) || 1e4), new t({
        odpIntegrationConfig: n,
        segmentManager: u,
        eventManager: (null == i ? void 0 : i.eventManager) ? i.eventManager : new St({
          odpConfig: c,
          apiManager: new mt(l, r),
          logger: r,
          clientEngine: o,
          clientVersion: s,
          flushInterval: null == i ? void 0 : i.eventFlushInterval,
          batchSize: null == i ? void 0 : i.eventBatchSize,
          queueSize: null == i ? void 0 : i.eventQueueSize,
          userAgentParser: null == i ? void 0 : i.userAgentParser
        }),
        logger: r
      });
    }, t.prototype.initializeVuid = function () {
      return u(this, void 0, void 0, function () {
        var e;
        return l(this, function (r) {
          switch (r.label) {
            case 0:
              return [4, It.instance(t.cache)];
            case 1:
              return e = r.sent(), this.vuid = e.vuid, [2];
          }
        });
      });
    }, t.prototype.identifyUser = function (t, r) {
      t && It.isVuid(t) ? e.prototype.identifyUser.call(this, void 0, t) : t && r && It.isVuid(r) ? e.prototype.identifyUser.call(this, t, r) : e.prototype.identifyUser.call(this, t, r || this.vuid);
    }, t.prototype.sendEvent = function (t) {
      var r = t.type,
        i = t.action,
        n = t.identifiers,
        o = t.data,
        s = new Map(n);
      if (!n.has(ee.VUID)) {
        if (!this.vuid) throw new Error(H.ODP_SEND_EVENT_FAILED_VUID_MISSING);
        s.set(ee.VUID, this.vuid);
      }
      e.prototype.sendEvent.call(this, {
        type: r,
        action: i,
        identifiers: s,
        data: o
      });
    }, t.prototype.isVuidEnabled = function () {
      return !0;
    }, t.prototype.getVuid = function () {
      return this.vuid;
    }, t.cache = new lt(), t;
  }(Nt);
function Mt(e, t, r) {
  return {
    variationKey: null,
    enabled: !1,
    variables: {},
    ruleKey: null,
    flagKey: e,
    userContext: t,
    reasons: r
  };
}
var Ft = function () {
    function e(e) {
      var t,
        r = e.optimizely,
        i = e.userId,
        n = e.attributes,
        o = e.shouldIdentifyUser,
        s = void 0 === o || o,
        u = this;
      this._qualifiedSegments = null, this.optimizely = r, this.userId = i, this.attributes = null !== (t = _a({}, n)) && void 0 !== t ? t : {}, this.forcedDecisionsMap = {}, s && r.readyPromise.then(function (e) {
        e.success && r.isOdpIntegrated() && u.identifyUser();
      });
    }
    return e.prototype.identifyUser = function () {
      this.optimizely.identifyUser(this.userId);
    }, e.prototype.setAttribute = function (e, t) {
      this.attributes[e] = t;
    }, e.prototype.getUserId = function () {
      return this.userId;
    }, e.prototype.getAttributes = function () {
      return _a({}, this.attributes);
    }, e.prototype.getOptimizely = function () {
      return this.optimizely;
    }, Object.defineProperty(e.prototype, "qualifiedSegments", {
      get: function get() {
        return this._qualifiedSegments;
      },
      set: function set(e) {
        this._qualifiedSegments = e;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.decide = function (e, t) {
      return void 0 === t && (t = []), this.optimizely.decide(this.cloneUserContext(), e, t);
    }, e.prototype.decideForKeys = function (e, t) {
      return void 0 === t && (t = []), this.optimizely.decideForKeys(this.cloneUserContext(), e, t);
    }, e.prototype.decideAll = function (e) {
      return void 0 === e && (e = []), this.optimizely.decideAll(this.cloneUserContext(), e);
    }, e.prototype.trackEvent = function (e, t) {
      this.optimizely.track(e, this.userId, this.attributes, t);
    }, e.prototype.setForcedDecision = function (e, t) {
      var r,
        i = e.flagKey,
        n = null !== (r = e.ruleKey) && void 0 !== r ? r : Y.FORCED_DECISION_NULL_RULE_KEY,
        o = {
          variationKey: t.variationKey
        };
      return this.forcedDecisionsMap[i] || (this.forcedDecisionsMap[i] = {}), this.forcedDecisionsMap[i][n] = o, !0;
    }, e.prototype.getForcedDecision = function (e) {
      return this.findForcedDecision(e);
    }, e.prototype.removeForcedDecision = function (e) {
      var t,
        r = null !== (t = e.ruleKey) && void 0 !== t ? t : Y.FORCED_DECISION_NULL_RULE_KEY,
        i = e.flagKey,
        n = !1;
      this.forcedDecisionsMap.hasOwnProperty(i) && (this.forcedDecisionsMap[i].hasOwnProperty(r) && (delete this.forcedDecisionsMap[i][r], n = !0), 0 === Object.keys(this.forcedDecisionsMap[i]).length && delete this.forcedDecisionsMap[i]);
      return n;
    }, e.prototype.removeAllForcedDecisions = function () {
      return this.forcedDecisionsMap = {}, !0;
    }, e.prototype.findForcedDecision = function (e) {
      var t,
        r = null !== (t = e.ruleKey) && void 0 !== t ? t : Y.FORCED_DECISION_NULL_RULE_KEY,
        i = e.flagKey;
      if (this.forcedDecisionsMap.hasOwnProperty(e.flagKey)) {
        var n = this.forcedDecisionsMap[i];
        if (n.hasOwnProperty(r)) return {
          variationKey: n[r].variationKey
        };
      }
      return null;
    }, e.prototype.cloneUserContext = function () {
      var t = new e({
        shouldIdentifyUser: !1,
        optimizely: this.getOptimizely(),
        userId: this.getUserId(),
        attributes: this.getAttributes()
      });
      return Object.keys(this.forcedDecisionsMap).length > 0 && (t.forcedDecisionsMap = _a({}, this.forcedDecisionsMap)), t._qualifiedSegments = this._qualifiedSegments, t;
    }, e.prototype.fetchQualifiedSegments = function (e) {
      return u(this, void 0, void 0, function () {
        var t;
        return l(this, function (r) {
          switch (r.label) {
            case 0:
              return [4, this.optimizely.fetchQualifiedSegments(this.userId, e)];
            case 1:
              return t = r.sent(), this.qualifiedSegments = t, [2, null !== t];
          }
        });
      });
    }, e.prototype.isQualifiedFor = function (e) {
      return !!this._qualifiedSegments && this._qualifiedSegments.indexOf(e) > -1;
    }, e;
  }(),
  xt = ["and", "or", "not"];
function kt(e, t) {
  if (Array.isArray(e)) {
    var r = e[0],
      i = e.slice(1);
    switch ("string" == typeof r && -1 === xt.indexOf(r) && (r = "or", i = e), r) {
      case "and":
        return function (e, t) {
          var r = !1;
          if (Array.isArray(e)) {
            for (var i = 0; i < e.length; i++) {
              var n = kt(e[i], t);
              if (!1 === n) return !1;
              null === n && (r = !0);
            }
            return !r || null;
          }
          return null;
        }(i, t);
      case "not":
        return function (e, t) {
          if (Array.isArray(e) && e.length > 0) {
            var r = kt(e[0], t);
            return null === r ? null : !r;
          }
          return null;
        }(i, t);
      default:
        return function (e, t) {
          var r = !1;
          if (Array.isArray(e)) {
            for (var i = 0; i < e.length; i++) {
              var n = kt(e[i], t);
              if (!0 === n) return !0;
              null === n && (r = !0);
            }
            return !!r && null;
          }
          return null;
        }(i, t);
    }
  }
  return t(e);
}
var wt = function () {
  function e(t, r, i) {
    var n, o;
    this.sdkKey = null !== (n = t.sdkKey) && void 0 !== n ? n : "", this.environmentKey = null !== (o = t.environmentKey) && void 0 !== o ? o : "", this.attributes = t.attributes, this.audiences = e.getAudiences(t), this.events = t.events, this.revision = t.revision;
    var s = (t.featureFlags || []).reduce(function (e, t) {
        return e[t.id] = t.variables, e;
      }, {}),
      a = e.getVariableIdMap(t),
      u = e.getExperimentsMap(t, s, a, i),
      l = u.experimentsMapById,
      c = u.experimentsMapByKey;
    this.experimentsMap = c, this.featuresMap = e.getFeaturesMap(t, s, l, a), this.datafile = r;
  }
  return e.prototype.getDatafile = function () {
    return this.datafile;
  }, e.getAudiences = function (e) {
    var t = [],
      r = [];
    return (e.typedAudiences || []).forEach(function (e) {
      t.push({
        id: e.id,
        conditions: JSON.stringify(e.conditions),
        name: e.name
      }), r.push(e.id);
    }), (e.audiences || []).forEach(function (e) {
      -1 === r.indexOf(e.id) && "$opt_dummy_audience" != e.id && t.push({
        id: e.id,
        conditions: JSON.stringify(e.conditions),
        name: e.name
      });
    }), t;
  }, e.getSerializedAudiences = function (t, r) {
    var i = "";
    if (t) {
      var n = "";
      t.forEach(function (t) {
        var o = "";
        if (t instanceof Array) o = e.getSerializedAudiences(t, r), o = "(".concat(o, ")");else if (xt.indexOf(t) > -1) n = t.toUpperCase();else {
          var s = r[t] ? r[t].name : t;
          i || "NOT" === n ? (n = "" === n ? "OR" : n, i = "" === i ? "".concat(n, ' "').concat(r[t].name, '"') : i.concat(" ".concat(n, ' "').concat(s, '"'))) : i = '"'.concat(s, '"');
        }
        "" !== o && ("" !== i || "NOT" === n ? (n = "" === n ? "OR" : n, i = "" === i ? "".concat(n, " ").concat(o) : i.concat(" ".concat(n, " ").concat(o))) : i = i.concat(o));
      });
    }
    return i;
  }, e.getExperimentAudiences = function (t, r) {
    return t.audienceConditions ? e.getSerializedAudiences(t.audienceConditions, r.audiencesById) : "";
  }, e.mergeFeatureVariables = function (e, t, r, i, n) {
    var o = (e[r] || []).reduce(function (e, t) {
      return e[t.key] = {
        id: t.id,
        key: t.key,
        type: t.type,
        value: t.defaultValue
      }, e;
    }, {});
    return (i || []).forEach(function (e) {
      var r = t[e.id],
        i = {
          id: e.id,
          key: r.key,
          type: r.type,
          value: n ? e.value : r.defaultValue
        };
      o[r.key] = i;
    }), o;
  }, e.getVariationsMap = function (t, r, i, n) {
    return t.reduce(function (t, o) {
      var s = e.mergeFeatureVariables(r, i, n, o.variables, o.featureEnabled);
      return t[o.key] = {
        id: o.id,
        key: o.key,
        featureEnabled: o.featureEnabled,
        variablesMap: s
      }, t;
    }, {});
  }, e.getVariableIdMap = function (e) {
    return (e.featureFlags || []).reduce(function (e, t) {
      return t.variables.forEach(function (t) {
        e[t.id] = t;
      }), e;
    }, {});
  }, e.getDeliveryRules = function (t, r, i, n, o) {
    return n.map(function (n) {
      return {
        id: n.id,
        key: n.key,
        audiences: e.getExperimentAudiences(n, t),
        variationsMap: e.getVariationsMap(n.variations, r, o, i)
      };
    });
  }, e.getRolloutExperimentIds = function (e) {
    var t = [];
    return (e || []).forEach(function (e) {
      e.experiments.forEach(function (e) {
        t.push(e.id);
      });
    }), t;
  }, e.getExperimentsMap = function (t, r, i, n) {
    var o = this.getRolloutExperimentIds(t.rollouts),
      s = {},
      a = {};
    return (t.experiments || []).forEach(function (u) {
      if (-1 === o.indexOf(u.id)) {
        var l = t.experimentFeatureMap[u.id],
          c = "";
        l && l.length > 0 && (c = l[0]);
        var p = e.getVariationsMap(u.variations, r, i, c.toString()),
          d = {
            id: u.id,
            key: u.key,
            audiences: e.getExperimentAudiences(u, t),
            variationsMap: p
          };
        s[u.id] = d, a[u.key] && n && n.warn("Duplicate experiment keys found in datafile: ".concat(u.key)), a[u.key] = d;
      }
    }), {
      experimentsMapById: s,
      experimentsMapByKey: a
    };
  }, e.getExperimentsKeyMap = function (e) {
    var t = {};
    for (var r in e) {
      var i = e[r];
      t[i.key] = i;
    }
    return t;
  }, e.getFeaturesMap = function (t, r, i, n) {
    var o = {};
    return t.featureFlags.forEach(function (s) {
      var a = {},
        u = [];
      s.experimentIds.forEach(function (e) {
        var t = i[e];
        t && (a[t.key] = t), u.push(i[e]);
      });
      var l = (s.variables || []).reduce(function (e, t) {
          return e[t.key] = {
            id: t.id,
            key: t.key,
            type: t.type,
            value: t.defaultValue
          }, e;
        }, {}),
        c = [],
        p = t.rolloutIdMap[s.rolloutId];
      p && (c = e.getDeliveryRules(t, r, s.id, p.experiments, n)), o[s.key] = {
        id: s.id,
        key: s.key,
        experimentRules: u,
        deliveryRules: c,
        experimentsMap: a,
        variablesMap: l
      };
    }), o;
  }, e;
}();
var Gt = M();
function Bt(e, t) {
  return e instanceof Error ? e.message : t || "Unknown error";
}
var Kt = function () {
  function e(e) {
    this.updateListeners = [], this.configObj = null, this.optimizelyConfigObj = null, this.datafileManager = null;
    try {
      if (this.jsonSchemaValidator = e.jsonSchemaValidator, !e.datafile && !e.sdkKey) {
        var t = new Error(N(H.DATAFILE_AND_SDK_KEY_MISSING, "PROJECT_CONFIG_MANAGER"));
        return this.readyPromise = Promise.resolve({
          success: !1,
          reason: Bt(t)
        }), void Gt.error(t);
      }
      var r = null;
      e.datafile && (r = this.handleNewDatafile(e.datafile)), e.sdkKey && e.datafileManager ? (this.datafileManager = e.datafileManager, this.datafileManager.start(), this.readyPromise = this.datafileManager.onReady().then(this.onDatafileManagerReadyFulfill.bind(this), this.onDatafileManagerReadyReject.bind(this)), this.datafileManager.on("update", this.onDatafileManagerUpdate.bind(this))) : this.configObj ? this.readyPromise = Promise.resolve({
        success: !0
      }) : this.readyPromise = Promise.resolve({
        success: !1,
        reason: Bt(r, "Invalid datafile")
      });
    } catch (e) {
      Gt.error(e), this.readyPromise = Promise.resolve({
        success: !1,
        reason: Bt(e, "Error in initialize")
      });
    }
  }
  return e.prototype.onDatafileManagerReadyFulfill = function () {
    if (this.datafileManager) {
      var e = this.handleNewDatafile(this.datafileManager.get());
      return e ? {
        success: !1,
        reason: Bt(e)
      } : {
        success: !0
      };
    }
    return {
      success: !1,
      reason: Bt(null, "Datafile manager is not provided")
    };
  }, e.prototype.onDatafileManagerReadyReject = function (e) {
    return {
      success: !1,
      reason: Bt(e, "Failed to become ready")
    };
  }, e.prototype.onDatafileManagerUpdate = function () {
    this.datafileManager && this.handleNewDatafile(this.datafileManager.get());
  }, e.prototype.handleNewDatafile = function (e) {
    var t = this,
      r = nt({
        datafile: e,
        jsonSchemaValidator: this.jsonSchemaValidator,
        logger: Gt
      }),
      i = r.configObj,
      n = r.error;
    if (n) Gt.error(n);else {
      var o = this.configObj ? this.configObj.revision : "null";
      i && o !== i.revision && (this.configObj = i, this.optimizelyConfigObj = null, At(function () {
        t.updateListeners.forEach(function (e) {
          return e(i);
        });
      }));
    }
    return n;
  }, e.prototype.getConfig = function () {
    return this.configObj;
  }, e.prototype.getOptimizelyConfig = function () {
    return !this.optimizelyConfigObj && this.configObj && (this.optimizelyConfigObj = function (e, t, r) {
      return new wt(e, t, r);
    }(this.configObj, it(this.configObj), Gt)), this.optimizelyConfigObj;
  }, e.prototype.onReady = function () {
    return this.readyPromise;
  }, e.prototype.onUpdate = function (e) {
    var t = this;
    return this.updateListeners.push(e), function () {
      var r = t.updateListeners.indexOf(e);
      r > -1 && t.updateListeners.splice(r, 1);
    };
  }, e.prototype.stop = function () {
    this.datafileManager && this.datafileManager.stop(), this.updateListeners = [];
  }, e;
}();
var jt = Math.pow(2, 32),
  qt = function qt(e) {
    var t = [],
      r = e.experimentIdMap[e.experimentId].groupId;
    if (r) {
      var i = e.groupIdMap[r];
      if (!i) throw new Error(N(H.INVALID_GROUP_ID, "BUCKETER", r));
      if ("random" === i.policy) {
        var n = Ht(i, e.bucketingId, e.userId, e.logger);
        if (null === n) return e.logger.log(q.INFO, z.USER_NOT_IN_ANY_EXPERIMENT, "BUCKETER", e.userId, r), t.push([z.USER_NOT_IN_ANY_EXPERIMENT, "BUCKETER", e.userId, r]), {
          result: null,
          reasons: t
        };
        if (n !== e.experimentId) return e.logger.log(q.INFO, z.USER_NOT_BUCKETED_INTO_EXPERIMENT_IN_GROUP, "BUCKETER", e.userId, e.experimentKey, r), t.push([z.USER_NOT_BUCKETED_INTO_EXPERIMENT_IN_GROUP, "BUCKETER", e.userId, e.experimentKey, r]), {
          result: null,
          reasons: t
        };
        e.logger.log(q.INFO, z.USER_BUCKETED_INTO_EXPERIMENT_IN_GROUP, "BUCKETER", e.userId, e.experimentKey, r), t.push([z.USER_BUCKETED_INTO_EXPERIMENT_IN_GROUP, "BUCKETER", e.userId, e.experimentKey, r]);
      }
    }
    var o = "".concat(e.bucketingId).concat(e.experimentId),
      s = Yt(o);
    e.logger.log(q.DEBUG, z.USER_ASSIGNED_TO_EXPERIMENT_BUCKET, "BUCKETER", s, e.userId), t.push([z.USER_ASSIGNED_TO_EXPERIMENT_BUCKET, "BUCKETER", s, e.userId]);
    var a = zt(s, e.trafficAllocationConfig);
    return null === a || e.variationIdMap[a] ? {
      result: a,
      reasons: t
    } : (a && (e.logger.log(q.WARNING, z.INVALID_VARIATION_ID, "BUCKETER"), t.push([z.INVALID_VARIATION_ID, "BUCKETER"])), {
      result: null,
      reasons: t
    });
  },
  Ht = function Ht(e, t, r, i) {
    var n = "".concat(t).concat(e.id),
      o = Yt(n);
    i.log(q.DEBUG, z.USER_ASSIGNED_TO_EXPERIMENT_BUCKET, "BUCKETER", o, r);
    var s = e.trafficAllocation;
    return zt(o, s);
  },
  zt = function zt(e, t) {
    for (var r = 0; r < t.length; r++) if (e < t[r].endOfRange) return t[r].entityId;
    return null;
  },
  Yt = function Yt(e) {
    try {
      var t = i.v3(e, 1) / jt;
      return Math.floor(1e4 * t);
    } catch (t) {
      throw new Error(N(H.INVALID_BUCKETING_ID, "BUCKETER", e, t.message));
    }
  },
  Xt = M();
function Jt(e) {
  return /^\d+$/.test(e);
}
function Wt(e) {
  var t = e.indexOf("-"),
    r = e.indexOf("+");
  return !(t < 0) && (r < 0 || t < r);
}
function Zt(e) {
  var t = e.indexOf("-"),
    r = e.indexOf("+");
  return !(r < 0) && (t < 0 || r < t);
}
function Qt(e) {
  var t = e,
    r = "";
  if (function (e) {
    return /\s/.test(e);
  }(e)) return Xt.warn(z.UNKNOWN_MATCH_TYPE, "SEMANTIC VERSION", e), null;
  if (Wt(e) ? (t = e.substring(0, e.indexOf("-")), r = e.substring(e.indexOf("-") + 1)) : Zt(e) && (t = e.substring(0, e.indexOf("+")), r = e.substring(e.indexOf("+") + 1)), "string" != typeof t || "string" != typeof r) return null;
  var i = t.split(".").length - 1;
  if (i > 2) return Xt.warn(z.UNKNOWN_MATCH_TYPE, "SEMANTIC VERSION", e), null;
  var n = t.split(".");
  if (n.length != i + 1) return Xt.warn(z.UNKNOWN_MATCH_TYPE, "SEMANTIC VERSION", e), null;
  for (var o = 0, s = n; o < s.length; o++) {
    if (!Jt(s[o])) return Xt.warn(z.UNKNOWN_MATCH_TYPE, "SEMANTIC VERSION", e), null;
  }
  return r && n.push(r), n;
}
var $t = "CUSTOM_ATTRIBUTE_CONDITION_EVALUATOR",
  er = M(),
  tr = ["exact", "exists", "gt", "ge", "lt", "le", "substring", "semver_eq", "semver_lt", "semver_le", "semver_gt", "semver_ge"],
  rr = {};
function ir(e) {
  return "string" == typeof e || "boolean" == typeof e || A.isNumber(e);
}
function nr(e, t) {
  var r = t.getAttributes(),
    i = e.value,
    n = typeof i,
    o = e.name,
    s = r[o],
    a = typeof s;
  return !ir(i) || A.isNumber(i) && !A.isSafeInteger(i) ? (er.warn(z.UNEXPECTED_CONDITION_VALUE, $t, JSON.stringify(e)), null) : null === s ? (er.debug(z.UNEXPECTED_TYPE_NULL, $t, JSON.stringify(e), o), null) : ir(s) && n === a ? A.isNumber(s) && !A.isSafeInteger(s) ? (er.warn(z.OUT_OF_BOUNDS, $t, JSON.stringify(e), o), null) : i === s : (er.warn(z.UNEXPECTED_TYPE, $t, JSON.stringify(e), a, o), null);
}
function or(e, t) {
  var r = t.getAttributes(),
    i = e.name,
    n = r[i],
    o = typeof n,
    s = e.value;
  return null !== s && A.isSafeInteger(s) ? null === n ? (er.debug(z.UNEXPECTED_TYPE_NULL, $t, JSON.stringify(e), i), !1) : A.isNumber(n) ? !!A.isSafeInteger(n) || (er.warn(z.OUT_OF_BOUNDS, $t, JSON.stringify(e), i), !1) : (er.warn(z.UNEXPECTED_TYPE, $t, JSON.stringify(e), o, i), !1) : (er.warn(z.UNEXPECTED_CONDITION_VALUE, $t, JSON.stringify(e)), !1);
}
function sr(e, t) {
  var r = t.getAttributes(),
    i = e.name,
    n = r[i],
    o = typeof n,
    s = e.value;
  return "string" != typeof s ? (er.warn(z.UNEXPECTED_CONDITION_VALUE, $t, JSON.stringify(e)), null) : null === n ? (er.debug(z.UNEXPECTED_TYPE_NULL, $t, JSON.stringify(e), i), null) : "string" != typeof n ? (er.warn(z.UNEXPECTED_TYPE, $t, JSON.stringify(e), o, i), null) : function (e, t) {
    var r = Qt(t),
      i = Qt(e);
    if (!r || !i) return null;
    for (var n = r.length, o = 0; o < i.length; o++) {
      if (n <= o) return Wt(e) || Zt(e) ? 1 : -1;
      if (Jt(r[o])) {
        var s = parseInt(r[o]),
          a = parseInt(i[o]);
        if (s > a) return 1;
        if (s < a) return -1;
      } else {
        if (r[o] < i[o]) return Wt(e) && !Wt(t) ? 1 : -1;
        if (r[o] > i[o]) return !Wt(e) && Wt(t) ? -1 : 1;
      }
    }
    return Wt(t) && !Wt(e) ? -1 : 0;
  }(s, n);
}
rr.exact = nr, rr.exists = function (e, t) {
  var r = t.getAttributes()[e.name];
  return null != r;
}, rr.gt = function (e, t) {
  var r = t.getAttributes()[e.name],
    i = e.value;
  if (!or(e, t) || null === i) return null;
  return r > i;
}, rr.ge = function (e, t) {
  var r = t.getAttributes()[e.name],
    i = e.value;
  if (!or(e, t) || null === i) return null;
  return r >= i;
}, rr.lt = function (e, t) {
  var r = t.getAttributes()[e.name],
    i = e.value;
  if (!or(e, t) || null === i) return null;
  return r < i;
}, rr.le = function (e, t) {
  var r = t.getAttributes()[e.name],
    i = e.value;
  if (!or(e, t) || null === i) return null;
  return r <= i;
}, rr.substring = function (e, t) {
  var r = t.getAttributes(),
    i = e.name,
    n = r[e.name],
    o = typeof n,
    s = e.value;
  if ("string" != typeof s) return er.warn(z.UNEXPECTED_CONDITION_VALUE, $t, JSON.stringify(e)), null;
  if (null === n) return er.debug(z.UNEXPECTED_TYPE_NULL, $t, JSON.stringify(e), i), null;
  if ("string" != typeof n) return er.warn(z.UNEXPECTED_TYPE, $t, JSON.stringify(e), o, i), null;
  return -1 !== n.indexOf(s);
}, rr.semver_eq = function (e, t) {
  var r = sr(e, t);
  if (null === r) return null;
  return 0 === r;
}, rr.semver_gt = function (e, t) {
  var r = sr(e, t);
  if (null === r) return null;
  return r > 0;
}, rr.semver_ge = function (e, t) {
  var r = sr(e, t);
  if (null === r) return null;
  return r >= 0;
}, rr.semver_lt = function (e, t) {
  var r = sr(e, t);
  if (null === r) return null;
  return r < 0;
}, rr.semver_le = function (e, t) {
  var r = sr(e, t);
  if (null === r) return null;
  return r <= 0;
};
var ar = Object.freeze({
    __proto__: null,
    evaluate: function evaluate(e, t) {
      var r = t.getAttributes(),
        i = e.match;
      if (void 0 !== i && -1 === tr.indexOf(i)) return er.warn(z.UNKNOWN_MATCH_TYPE, $t, JSON.stringify(e)), null;
      var n = e.name;
      return r.hasOwnProperty(n) || "exists" == i ? (i && rr[i] || nr)(e, t) : (er.debug(z.MISSING_ATTRIBUTE_VALUE, $t, JSON.stringify(e), n), null);
    }
  }),
  ur = M(),
  lr = ["qualified"],
  cr = {};
function pr(e, t) {
  return t.isQualifiedFor(e.value);
}
cr.qualified = pr;
var dr = Object.freeze({
    __proto__: null,
    evaluate: function evaluate(e, t) {
      var r = e.match;
      return void 0 !== r && -1 === lr.indexOf(r) ? (ur.warn(z.UNKNOWN_MATCH_TYPE, "ODP_SEGMENT_CONDITION_EVALUATOR", JSON.stringify(e)), null) : (r && cr[r] || pr)(e, t);
    }
  }),
  fr = M(),
  gr = function () {
    function e(e) {
      this.typeToEvaluatorMap = A.assign({}, e, {
        custom_attribute: ar,
        third_party_dimension: dr
      });
    }
    return e.prototype.evaluate = function (e, t, r) {
      var i = this;
      if (!e || 0 === e.length) return !0;
      return !!kt(e, function (e) {
        var n = t[e];
        if (n) {
          fr.log(q.DEBUG, z.EVALUATING_AUDIENCE, "AUDIENCE_EVALUATOR", e, JSON.stringify(n.conditions));
          var o = kt(n.conditions, i.evaluateConditionWithUserAttributes.bind(i, r)),
            s = null === o ? "UNKNOWN" : o.toString().toUpperCase();
          return fr.log(q.DEBUG, z.AUDIENCE_EVALUATION_RESULT, "AUDIENCE_EVALUATOR", e, s), o;
        }
        return null;
      });
    }, e.prototype.evaluateConditionWithUserAttributes = function (e, t) {
      var r = this.typeToEvaluatorMap[t.type];
      if (!r) return fr.log(q.WARNING, z.UNKNOWN_CONDITION_TYPE, "AUDIENCE_EVALUATOR", JSON.stringify(t)), null;
      try {
        return r.evaluate(t, e);
      } catch (e) {
        fr.log(q.ERROR, H.CONDITION_EVALUATOR_ERROR, "AUDIENCE_EVALUATOR", t.type, e.message);
      }
      return null;
    }, e;
  }();
function Er(e) {
  return "string" == typeof e && "" !== e;
}
var hr = "DECISION_SERVICE",
  Ir = function () {
    function e(e) {
      var t;
      this.audienceEvaluator = (t = e.UNSTABLE_conditionEvaluators, new gr(t)), this.forcedVariationMap = {}, this.logger = e.logger, this.userProfileService = e.userProfileService || null;
    }
    return e.prototype.getVariation = function (e, t, r, i) {
      void 0 === i && (i = {});
      var n = r.getUserId(),
        o = r.getAttributes(),
        s = this.getBucketingId(n, o),
        a = [],
        u = t.key;
      if (!this.checkIfExperimentIsActive(e, u)) return this.logger.log(q.INFO, z.EXPERIMENT_NOT_RUNNING, hr, u), a.push([z.EXPERIMENT_NOT_RUNNING, hr, u]), {
        result: null,
        reasons: a
      };
      var l = this.getForcedVariation(e, u, n);
      a.push.apply(a, l.reasons);
      var c = l.result;
      if (c) return {
        result: c,
        reasons: a
      };
      var p = this.getWhitelistedVariation(t, n);
      a.push.apply(a, p.reasons);
      var d = p.result;
      if (d) return {
        result: d.key,
        reasons: a
      };
      var f = i[exports.OptimizelyDecideOption.IGNORE_USER_PROFILE_SERVICE],
        g = this.resolveExperimentBucketMap(n, o);
      if (!f && (d = this.getStoredVariation(e, t, n, g))) return this.logger.log(q.INFO, z.RETURNING_STORED_VARIATION, hr, d.key, u, n), a.push([z.RETURNING_STORED_VARIATION, hr, d.key, u, n]), {
        result: d.key,
        reasons: a
      };
      var E = this.checkIfUserIsInAudience(e, t, W.EXPERIMENT, r, "");
      if (a.push.apply(a, E.reasons), !E.result) return this.logger.log(q.INFO, z.USER_NOT_IN_EXPERIMENT, hr, n, u), a.push([z.USER_NOT_IN_EXPERIMENT, hr, n, u]), {
        result: null,
        reasons: a
      };
      var h = this.buildBucketerParams(e, t, s, n),
        I = qt(h);
      a.push.apply(a, I.reasons);
      var _ = I.result;
      return _ && (d = e.variationIdMap[_]), d ? (this.logger.log(q.INFO, z.USER_HAS_VARIATION, hr, n, d.key, u), a.push([z.USER_HAS_VARIATION, hr, n, d.key, u]), f || this.saveUserProfile(t, d, n, g), {
        result: d.key,
        reasons: a
      }) : (this.logger.log(q.DEBUG, z.USER_HAS_NO_VARIATION, hr, n, u), a.push([z.USER_HAS_NO_VARIATION, hr, n, u]), {
        result: null,
        reasons: a
      });
    }, e.prototype.resolveExperimentBucketMap = function (e, t) {
      t = t || {};
      var r = this.getUserProfile(e) || {},
        i = t[Y.STICKY_BUCKETING_KEY];
      return A.assign({}, r.experiment_bucket_map, i);
    }, e.prototype.checkIfExperimentIsActive = function (e, t) {
      return function (e, t) {
        return "Running" === We(e, t);
      }(e, t);
    }, e.prototype.getWhitelistedVariation = function (e, t) {
      var r = [];
      if (e.forcedVariations && e.forcedVariations.hasOwnProperty(t)) {
        var i = e.forcedVariations[t];
        return e.variationKeyMap.hasOwnProperty(i) ? (this.logger.log(q.INFO, z.USER_FORCED_IN_VARIATION, hr, t, i), r.push([z.USER_FORCED_IN_VARIATION, hr, t, i]), {
          result: e.variationKeyMap[i],
          reasons: r
        }) : (this.logger.log(q.ERROR, z.FORCED_BUCKETING_FAILED, hr, i, t), r.push([z.FORCED_BUCKETING_FAILED, hr, i, t]), {
          result: null,
          reasons: r
        });
      }
      return {
        result: null,
        reasons: r
      };
    }, e.prototype.checkIfUserIsInAudience = function (e, t, r, i, n) {
      var o = [],
        s = function (e, t) {
          var r = e.experimentIdMap[t];
          if (!r) throw new Error(N(H.INVALID_EXPERIMENT_ID, je, t));
          return r.audienceConditions || r.audienceIds;
        }(e, t.id),
        a = e.audiencesById;
      this.logger.log(q.DEBUG, z.EVALUATING_AUDIENCES_COMBINED, hr, r, n || t.key, JSON.stringify(s)), o.push([z.EVALUATING_AUDIENCES_COMBINED, hr, r, n || t.key, JSON.stringify(s)]);
      var u = this.audienceEvaluator.evaluate(s, a, i);
      return this.logger.log(q.INFO, z.AUDIENCE_EVALUATION_RESULT_COMBINED, hr, r, n || t.key, u.toString().toUpperCase()), o.push([z.AUDIENCE_EVALUATION_RESULT_COMBINED, hr, r, n || t.key, u.toString().toUpperCase()]), {
        result: u,
        reasons: o
      };
    }, e.prototype.buildBucketerParams = function (e, t, r, i) {
      return {
        bucketingId: r,
        experimentId: t.id,
        experimentKey: t.key,
        experimentIdMap: e.experimentIdMap,
        experimentKeyMap: e.experimentKeyMap,
        groupIdMap: e.groupIdMap,
        logger: this.logger,
        trafficAllocationConfig: $e(e, t.id),
        userId: i,
        variationIdMap: e.variationIdMap
      };
    }, e.prototype.getStoredVariation = function (e, t, r, i) {
      if (i.hasOwnProperty(t.id)) {
        var n = i[t.id],
          o = n.variation_id;
        if (e.variationIdMap.hasOwnProperty(o)) return e.variationIdMap[n.variation_id];
        this.logger.log(q.INFO, z.SAVED_VARIATION_NOT_FOUND, hr, r, o, t.key);
      }
      return null;
    }, e.prototype.getUserProfile = function (e) {
      var t = {
        user_id: e,
        experiment_bucket_map: {}
      };
      if (!this.userProfileService) return t;
      try {
        return this.userProfileService.lookup(e);
      } catch (t) {
        this.logger.log(q.ERROR, H.USER_PROFILE_LOOKUP_ERROR, hr, e, t.message);
      }
      return null;
    }, e.prototype.saveUserProfile = function (e, t, r, i) {
      if (this.userProfileService) try {
        i[e.id] = {
          variation_id: t.id
        }, this.userProfileService.save({
          user_id: r,
          experiment_bucket_map: i
        }), this.logger.log(q.INFO, z.SAVED_VARIATION, hr, t.key, e.key, r);
      } catch (e) {
        this.logger.log(q.ERROR, H.USER_PROFILE_SAVE_ERROR, hr, r, e.message);
      }
    }, e.prototype.getVariationForFeature = function (e, t, r, i) {
      void 0 === i && (i = {});
      var n = [],
        o = this.getVariationForFeatureExperiment(e, t, r, i);
      n.push.apply(n, o.reasons);
      var s = o.result;
      if (null !== s.variation) return {
        result: s,
        reasons: n
      };
      var a = this.getVariationForRollout(e, t, r);
      n.push.apply(n, a.reasons);
      var u = a.result,
        l = r.getUserId();
      return u.variation ? (this.logger.log(q.DEBUG, z.USER_IN_ROLLOUT, hr, l, t.key), n.push([z.USER_IN_ROLLOUT, hr, l, t.key]), {
        result: u,
        reasons: n
      }) : (this.logger.log(q.DEBUG, z.USER_NOT_IN_ROLLOUT, hr, l, t.key), n.push([z.USER_NOT_IN_ROLLOUT, hr, l, t.key]), {
        result: u,
        reasons: n
      });
    }, e.prototype.getVariationForFeatureExperiment = function (e, t, r, i) {
      void 0 === i && (i = {});
      var n,
        o,
        s = [],
        a = null;
      if (t.experimentIds.length > 0) for (o = 0; o < t.experimentIds.length; o++) {
        var u = et(e, t.experimentIds[o], this.logger);
        if (u && (n = this.getVariationFromExperimentRule(e, t.key, u, r, i), s.push.apply(s, n.reasons), a = n.result)) {
          var l = null;
          return (l = u.variationKeyMap[a]) || (l = tt(e, t.key, a)), {
            result: {
              experiment: u,
              variation: l,
              decisionSource: J.FEATURE_TEST
            },
            reasons: s
          };
        }
      } else this.logger.log(q.DEBUG, z.FEATURE_HAS_NO_EXPERIMENTS, hr, t.key), s.push([z.FEATURE_HAS_NO_EXPERIMENTS, hr, t.key]);
      return {
        result: {
          experiment: null,
          variation: null,
          decisionSource: J.FEATURE_TEST
        },
        reasons: s
      };
    }, e.prototype.getVariationForRollout = function (e, t, r) {
      var i = [];
      if (!t.rolloutId) return this.logger.log(q.DEBUG, z.NO_ROLLOUT_EXISTS, hr, t.key), i.push([z.NO_ROLLOUT_EXISTS, hr, t.key]), {
        result: {
          experiment: null,
          variation: null,
          decisionSource: J.ROLLOUT
        },
        reasons: i
      };
      var n = e.rolloutIdMap[t.rolloutId];
      if (!n) return this.logger.log(q.ERROR, H.INVALID_ROLLOUT_ID, hr, t.rolloutId, t.key), i.push([H.INVALID_ROLLOUT_ID, hr, t.rolloutId, t.key]), {
        result: {
          experiment: null,
          variation: null,
          decisionSource: J.ROLLOUT
        },
        reasons: i
      };
      var o,
        s,
        a,
        u = n.experiments;
      if (0 === u.length) return this.logger.log(q.ERROR, z.ROLLOUT_HAS_NO_EXPERIMENTS, hr, t.rolloutId), i.push([z.ROLLOUT_HAS_NO_EXPERIMENTS, hr, t.rolloutId]), {
        result: {
          experiment: null,
          variation: null,
          decisionSource: J.ROLLOUT
        },
        reasons: i
      };
      for (var l = 0; l < u.length;) {
        if (o = this.getVariationFromDeliveryRule(e, t.key, u, l, r), i.push.apply(i, o.reasons), a = o.result, s = o.skipToEveryoneElse, a) return {
          result: {
            experiment: e.experimentIdMap[u[l].id],
            variation: a,
            decisionSource: J.ROLLOUT
          },
          reasons: i
        };
        l = s ? u.length - 1 : l + 1;
      }
      return {
        result: {
          experiment: null,
          variation: null,
          decisionSource: J.ROLLOUT
        },
        reasons: i
      };
    }, e.prototype.getBucketingId = function (e, t) {
      var r = e;
      return null != t && "object" == typeof t && t.hasOwnProperty(Y.BUCKETING_ID) && ("string" == typeof t[Y.BUCKETING_ID] ? (r = String(t[Y.BUCKETING_ID]), this.logger.log(q.DEBUG, z.VALID_BUCKETING_ID, hr, r)) : this.logger.log(q.WARNING, z.BUCKETING_ID_NOT_STRING, hr)), r;
    }, e.prototype.findValidatedForcedDecision = function (e, t, r, i) {
      var n,
        o = [],
        s = t.getForcedDecision({
          flagKey: r,
          ruleKey: i
        }),
        a = null,
        u = t.getUserId();
      return e && s && (n = s.variationKey, (a = tt(e, r, n)) ? i ? (this.logger.log(q.INFO, z.USER_HAS_FORCED_DECISION_WITH_RULE_SPECIFIED, n, r, i, u), o.push([z.USER_HAS_FORCED_DECISION_WITH_RULE_SPECIFIED, n, r, i, u])) : (this.logger.log(q.INFO, z.USER_HAS_FORCED_DECISION_WITH_NO_RULE_SPECIFIED, n, r, u), o.push([z.USER_HAS_FORCED_DECISION_WITH_NO_RULE_SPECIFIED, n, r, u])) : i ? (this.logger.log(q.INFO, z.USER_HAS_FORCED_DECISION_WITH_RULE_SPECIFIED_BUT_INVALID, r, i, u), o.push([z.USER_HAS_FORCED_DECISION_WITH_RULE_SPECIFIED_BUT_INVALID, r, i, u])) : (this.logger.log(q.INFO, z.USER_HAS_FORCED_DECISION_WITH_NO_RULE_SPECIFIED_BUT_INVALID, r, u), o.push([z.USER_HAS_FORCED_DECISION_WITH_NO_RULE_SPECIFIED_BUT_INVALID, r, u]))), {
        result: a,
        reasons: o
      };
    }, e.prototype.removeForcedVariation = function (e, t, r) {
      if (!e) throw new Error(N(H.INVALID_USER_ID, hr));
      if (!this.forcedVariationMap.hasOwnProperty(e)) throw new Error(N(H.USER_NOT_IN_FORCED_VARIATION, hr, e));
      delete this.forcedVariationMap[e][t], this.logger.log(q.DEBUG, z.VARIATION_REMOVED_FOR_USER, hr, r, e);
    }, e.prototype.setInForcedVariationMap = function (e, t, r) {
      this.forcedVariationMap.hasOwnProperty(e) || (this.forcedVariationMap[e] = {}), this.forcedVariationMap[e][t] = r, this.logger.log(q.DEBUG, z.USER_MAPPED_TO_FORCED_VARIATION, hr, r, t, e);
    }, e.prototype.getForcedVariation = function (e, t, r) {
      var i,
        n = [],
        o = this.forcedVariationMap[r];
      if (!o) return this.logger.log(q.DEBUG, z.USER_HAS_NO_FORCED_VARIATION, hr, r), {
        result: null,
        reasons: n
      };
      try {
        var s = Qe(e, t);
        if (!s.hasOwnProperty("id")) return this.logger.log(q.ERROR, H.IMPROPERLY_FORMATTED_EXPERIMENT, hr, t), n.push([H.IMPROPERLY_FORMATTED_EXPERIMENT, hr, t]), {
          result: null,
          reasons: n
        };
        i = s.id;
      } catch (e) {
        return this.logger.log(q.ERROR, e.message), n.push(e.message), {
          result: null,
          reasons: n
        };
      }
      var a = o[i];
      if (!a) return this.logger.log(q.DEBUG, z.USER_HAS_NO_FORCED_VARIATION_FOR_EXPERIMENT, hr, t, r), {
        result: null,
        reasons: n
      };
      var u = Ze(e, a);
      return u ? (this.logger.log(q.DEBUG, z.USER_HAS_FORCED_VARIATION, hr, u, t, r), n.push([z.USER_HAS_FORCED_VARIATION, hr, u, t, r])) : this.logger.log(q.DEBUG, z.USER_HAS_NO_FORCED_VARIATION_FOR_EXPERIMENT, hr, t, r), {
        result: u,
        reasons: n
      };
    }, e.prototype.setForcedVariation = function (e, t, r, i) {
      if (null != i && !Er(i)) return this.logger.log(q.ERROR, H.INVALID_VARIATION_KEY, hr), !1;
      var n;
      try {
        var o = Qe(e, t);
        if (!o.hasOwnProperty("id")) return this.logger.log(q.ERROR, H.IMPROPERLY_FORMATTED_EXPERIMENT, hr, t), !1;
        n = o.id;
      } catch (e) {
        return this.logger.log(q.ERROR, e.message), !1;
      }
      if (null == i) try {
        return this.removeForcedVariation(r, n, t), !0;
      } catch (e) {
        return this.logger.log(q.ERROR, e.message), !1;
      }
      var s = function (e, t, r) {
        var i = e.experimentKeyMap[t];
        return i.variationKeyMap.hasOwnProperty(r) ? i.variationKeyMap[r].id : null;
      }(e, t, i);
      if (!s) return this.logger.log(q.ERROR, H.NO_VARIATION_FOR_EXPERIMENT_KEY, hr, i, t), !1;
      try {
        return this.setInForcedVariationMap(r, n, s), !0;
      } catch (e) {
        return this.logger.log(q.ERROR, e.message), !1;
      }
    }, e.prototype.getVariationFromExperimentRule = function (e, t, r, i, n) {
      void 0 === n && (n = {});
      var o = [],
        s = this.findValidatedForcedDecision(e, i, t, r.key);
      o.push.apply(o, s.reasons);
      var a = s.result;
      if (a) return {
        result: a.key,
        reasons: o
      };
      var u = this.getVariation(e, r, i, n);
      return o.push.apply(o, u.reasons), {
        result: u.result,
        reasons: o
      };
    }, e.prototype.getVariationFromDeliveryRule = function (e, t, r, i, n) {
      var o = [],
        s = !1,
        a = r[i],
        u = this.findValidatedForcedDecision(e, n, t, a.key);
      o.push.apply(o, u.reasons);
      var l = u.result;
      if (l) return {
        result: l,
        reasons: o,
        skipToEveryoneElse: s
      };
      var c,
        p,
        d,
        f,
        g,
        E = n.getUserId(),
        h = n.getAttributes(),
        I = this.getBucketingId(E, h),
        _ = i === r.length - 1,
        v = _ ? "Everyone Else" : i + 1,
        y = null,
        O = this.checkIfUserIsInAudience(e, a, W.RULE, n, v);
      return o.push.apply(o, O.reasons), O.result ? (this.logger.log(q.DEBUG, z.USER_MEETS_CONDITIONS_FOR_TARGETING_RULE, hr, E, v), o.push([z.USER_MEETS_CONDITIONS_FOR_TARGETING_RULE, hr, E, v]), p = this.buildBucketerParams(e, a, I, E), d = qt(p), o.push.apply(o, d.reasons), (c = d.result) && (g = c, y = (f = e).variationIdMap.hasOwnProperty(g) ? f.variationIdMap[g] : null), y ? (this.logger.log(q.DEBUG, z.USER_BUCKETED_INTO_TARGETING_RULE, hr, E, v), o.push([z.USER_BUCKETED_INTO_TARGETING_RULE, hr, E, v])) : _ || (this.logger.log(q.DEBUG, z.USER_NOT_BUCKETED_INTO_TARGETING_RULE, hr, E, v), o.push([z.USER_NOT_BUCKETED_INTO_TARGETING_RULE, hr, E, v]), s = !0)) : (this.logger.log(q.DEBUG, z.USER_DOESNT_MEET_CONDITIONS_FOR_TARGETING_RULE, hr, E, v), o.push([z.USER_DOESNT_MEET_CONDITIONS_FOR_TARGETING_RULE, hr, E, v])), {
        result: y,
        reasons: o,
        skipToEveryoneElse: s
      };
    }, e;
  }();
function _r(e, t) {
  var r = e.revenue;
  if (null == r) return null;
  var i = "string" == typeof r ? parseInt(r) : r;
  return isFinite(i) ? (t.log(q.INFO, z.PARSED_REVENUE_VALUE, "EVENT_TAG_UTILS", i), i) : (t.log(q.INFO, z.FAILED_TO_PARSE_REVENUE, "EVENT_TAG_UTILS", r), null);
}
function vr(e, t) {
  var r = e.value;
  if (null == r) return null;
  var i = "string" == typeof r ? parseFloat(r) : r;
  return isFinite(i) ? (t.log(q.INFO, z.PARSED_NUMERIC_VALUE, "EVENT_TAG_UTILS", i), i) : (t.log(q.INFO, z.FAILED_TO_PARSE_VALUE, "EVENT_TAG_UTILS", r), null);
}
function yr(e, t) {
  return "string" == typeof e && ("string" == typeof t || "boolean" == typeof t || A.isNumber(t) && A.isSafeInteger(t));
}
var Or = "https://logx.optimizely.com/v1/events";
function Rr(e) {
  var t = e.attributes,
    r = e.userId,
    i = e.clientEngine,
    n = e.clientVersion,
    o = e.configObj,
    s = e.logger,
    a = !!o.anonymizeIP && o.anonymizeIP,
    u = o.botFiltering,
    l = {
      snapshots: [],
      visitor_id: r,
      attributes: []
    },
    c = {
      account_id: o.accountId,
      project_id: o.projectId,
      visitors: [l],
      revision: o.revision,
      client_name: i,
      client_version: n,
      anonymize_ip: a,
      enrich_decisions: !0
    };
  return t && Object.keys(t || {}).forEach(function (e) {
    var r = t[e];
    if (yr(e, r)) {
      var i = Xe(o, e, s);
      i && c.visitors[0].attributes.push({
        entity_id: i,
        key: e,
        type: "custom",
        value: r
      });
    }
  }), "boolean" == typeof u && c.visitors[0].attributes.push({
    entity_id: Y.BOT_FILTERING,
    key: Y.BOT_FILTERING,
    type: "custom",
    value: u
  }), c;
}
function Nr(e) {
  var t,
    r,
    i,
    n,
    o,
    s,
    a,
    u,
    l,
    c = Rr(e),
    p = (t = e.configObj, r = e.experimentId, i = e.variationId, n = e.ruleKey, o = e.ruleType, s = e.flagKey, a = e.enabled, u = r ? Ye(t, r) : null, l = i ? Ze(t, i) : null, {
      decisions: [{
        campaign_id: u,
        experiment_id: r,
        variation_id: i,
        metadata: {
          flag_key: s,
          rule_key: n,
          rule_type: o,
          variation_key: l = l || "",
          enabled: a
        }
      }],
      events: [{
        entity_id: u,
        timestamp: A.currentTimestamp(),
        key: "campaign_activated",
        uuid: A.uuid()
      }]
    });
  return c.visitors[0].snapshots.push(p), {
    httpVerb: "POST",
    url: Or,
    params: c
  };
}
function Tr(e) {
  var t = Rr(e),
    r = function (e, t, r, i) {
      var n = {
          events: []
        },
        o = {
          entity_id: Je(e, t),
          timestamp: A.currentTimestamp(),
          uuid: A.uuid(),
          key: t
        };
      if (i) {
        var s = _r(i, r);
        null !== s && (o.revenue = s);
        var a = vr(i, r);
        null !== a && (o.value = a), o.tags = i;
      }
      return n.events.push(o), n;
    }(e.configObj, e.eventKey, e.logger, e.eventTags);
  return t.visitors[0].snapshots = [r], {
    httpVerb: "POST",
    url: Or,
    params: t
  };
}
function mr(e) {
  var t, r;
  return null !== (r = null === (t = e.experiment) || void 0 === t ? void 0 : t.key) && void 0 !== r ? r : "";
}
function Ar(e) {
  var t, r;
  return null !== (r = null === (t = e.variation) || void 0 === t ? void 0 : t.key) && void 0 !== r ? r : "";
}
function Dr(e) {
  var t, r;
  return null !== (r = null === (t = e.variation) || void 0 === t ? void 0 : t.featureEnabled) && void 0 !== r && r;
}
function Sr(e) {
  var t, r;
  return null !== (r = null === (t = e.experiment) || void 0 === t ? void 0 : t.id) && void 0 !== r ? r : null;
}
function Lr(e) {
  var t, r;
  return null !== (r = null === (t = e.variation) || void 0 === t ? void 0 : t.id) && void 0 !== r ? r : null;
}
var Ur = M("EVENT_BUILDER");
function Cr(e, t) {
  var r = [];
  return t && Object.keys(t || {}).forEach(function (i) {
    var n = t[i];
    if (yr(i, n)) {
      var o = Xe(e, i, Ur);
      o && r.push({
        entityId: o,
        key: i,
        value: n
      });
    }
  }), r;
}
var Pr = "USER_PROFILE_SERVICE_VALIDATOR";
var br = function () {
    function e(e) {
      var t,
        r = this,
        i = e.clientEngine;
      i || (e.logger.log(q.INFO, z.INVALID_CLIENT_ENGINE, "OPTIMIZELY", i), i = "node-sdk"), this.clientEngine = i, this.clientVersion = e.clientVersion || "5.3.5", this.errorHandler = e.errorHandler, this.isOptimizelyConfigValid = e.isValidInstance, this.logger = e.logger, this.odpManager = e.odpManager;
      var n = null !== (t = e.defaultDecideOptions) && void 0 !== t ? t : [];
      Array.isArray(n) || (this.logger.log(q.DEBUG, z.INVALID_DEFAULT_DECIDE_OPTIONS, "OPTIMIZELY"), n = []);
      var o = {};
      n.forEach(function (e) {
        exports.OptimizelyDecideOption[e] ? o[e] = !0 : r.logger.log(q.WARNING, z.UNRECOGNIZED_DECIDE_OPTION, "OPTIMIZELY", e);
      }), this.defaultDecideOptions = o, this.projectConfigManager = function (e) {
        return new Kt(e);
      }({
        datafile: e.datafile,
        jsonSchemaValidator: e.jsonSchemaValidator,
        sdkKey: e.sdkKey,
        datafileManager: e.datafileManager
      }), this.disposeOnUpdate = this.projectConfigManager.onUpdate(function (e) {
        r.logger.log(q.INFO, z.UPDATED_OPTIMIZELY_CONFIG, "OPTIMIZELY", e.revision, e.projectId), r.notificationCenter.sendNotifications(w.OPTIMIZELY_CONFIG_UPDATE), r.updateOdpSettings();
      });
      var s,
        a = this.projectConfigManager.onReady(),
        u = null;
      if (e.userProfileService) try {
        (function (e) {
          if ("object" == typeof e && null !== e) {
            if ("function" != typeof e.lookup) throw new Error(N(H.INVALID_USER_PROFILE_SERVICE, Pr, "Missing function 'lookup'"));
            if ("function" != typeof e.save) throw new Error(N(H.INVALID_USER_PROFILE_SERVICE, Pr, "Missing function 'save'"));
            return !0;
          }
          throw new Error(N(H.INVALID_USER_PROFILE_SERVICE, Pr));
        })(e.userProfileService) && (u = e.userProfileService, this.logger.log(q.INFO, z.VALID_USER_PROFILE_SERVICE, "OPTIMIZELY"));
      } catch (e) {
        this.logger.log(q.WARNING, e.message);
      }
      this.decisionService = (s = {
        userProfileService: u,
        logger: this.logger,
        UNSTABLE_conditionEvaluators: e.UNSTABLE_conditionEvaluators
      }, new Ir(s)), this.notificationCenter = e.notificationCenter, this.eventProcessor = e.eventProcessor;
      var l = this.eventProcessor.start();
      this.readyPromise = Promise.all([a, l, e.odpManager ? e.odpManager.onReady() : Promise.resolve()]).then(function (e) {
        return e[0];
      }), this.readyTimeouts = {}, this.nextReadyTimeoutId = 0;
    }
    return e.prototype.getProjectConfig = function () {
      return this.projectConfigManager.getConfig();
    }, e.prototype.isValidInstance = function () {
      return this.isOptimizelyConfigValid && !!this.projectConfigManager.getConfig();
    }, e.prototype.activate = function (e, t, r) {
      try {
        if (!this.isValidInstance()) return this.logger.log(q.ERROR, z.INVALID_OBJECT, "OPTIMIZELY", "activate"), null;
        if (!this.validateInputs({
          experiment_key: e,
          user_id: t
        }, r)) return this.notActivatingExperiment(e, t);
        var i = this.projectConfigManager.getConfig();
        if (!i) return null;
        try {
          var n = this.getVariation(e, t, r);
          if (null === n) return this.notActivatingExperiment(e, t);
          if (!function (e, t) {
            return "Running" === We(e, t);
          }(i, e)) return this.logger.log(q.DEBUG, z.SHOULD_NOT_DISPATCH_ACTIVATE, "OPTIMIZELY", e), n;
          var o = Qe(i, e),
            s = {
              experiment: o,
              variation: o.variationKeyMap[n],
              decisionSource: J.EXPERIMENT
            };
          return this.sendImpressionEvent(s, "", t, !0, r), n;
        } catch (r) {
          return this.logger.log(q.ERROR, r.message), this.logger.log(q.INFO, z.NOT_ACTIVATING_USER, "OPTIMIZELY", t, e), this.errorHandler.handleError(r), null;
        }
      } catch (e) {
        return this.logger.log(q.ERROR, e.message), this.errorHandler.handleError(e), null;
      }
    }, e.prototype.sendImpressionEvent = function (e, t, r, i, n) {
      var o = this.projectConfigManager.getConfig();
      if (o) {
        var s = function (e) {
          var t = e.configObj,
            r = e.decisionObj,
            i = e.userId,
            n = e.flagKey,
            o = e.enabled,
            s = e.userAttributes,
            a = e.clientEngine,
            u = e.clientVersion,
            l = r.decisionSource,
            c = mr(r),
            p = Sr(r),
            d = Ar(r),
            f = Lr(r),
            g = null !== p ? Ye(t, p) : null;
          return {
            type: "impression",
            timestamp: A.currentTimestamp(),
            uuid: A.uuid(),
            user: {
              id: i,
              attributes: Cr(t, s)
            },
            context: {
              accountId: t.accountId,
              projectId: t.projectId,
              revision: t.revision,
              clientName: a,
              clientVersion: u,
              anonymizeIP: t.anonymizeIP || !1,
              botFiltering: t.botFiltering
            },
            layer: {
              id: g
            },
            experiment: {
              id: p,
              key: c
            },
            variation: {
              id: f,
              key: d
            },
            ruleKey: c,
            flagKey: n,
            ruleType: l,
            enabled: o
          };
        }({
          decisionObj: e,
          flagKey: t,
          enabled: i,
          userId: r,
          userAttributes: n,
          clientEngine: this.clientEngine,
          clientVersion: this.clientVersion,
          configObj: o
        });
        this.eventProcessor.process(s), this.emitNotificationCenterActivate(e, t, r, i, n);
      }
    }, e.prototype.emitNotificationCenterActivate = function (e, t, r, i, n) {
      var o = this.projectConfigManager.getConfig();
      if (o) {
        var s,
          a = e.decisionSource,
          u = mr(e),
          l = Sr(e),
          c = Ar(e),
          p = Lr(e);
        null !== l && "" !== c && (s = o.experimentIdMap[l]);
        var d,
          f = Nr({
            attributes: n,
            clientEngine: this.clientEngine,
            clientVersion: this.clientVersion,
            configObj: o,
            experimentId: l,
            ruleKey: u,
            flagKey: t,
            ruleType: a,
            userId: r,
            enabled: i,
            variationId: p,
            logger: this.logger
          });
        s && s.variationKeyMap && "" !== c && (d = s.variationKeyMap[c]), this.notificationCenter.sendNotifications(w.ACTIVATE, {
          experiment: s,
          userId: r,
          attributes: n,
          variation: d,
          logEvent: f
        });
      }
    }, e.prototype.track = function (e, t, r, i) {
      try {
        if (!this.isValidInstance()) return void this.logger.log(q.ERROR, z.INVALID_OBJECT, "OPTIMIZELY", "track");
        if (!this.validateInputs({
          user_id: t,
          event_key: e
        }, r, i)) return;
        var n = this.projectConfigManager.getConfig();
        if (!n) return;
        if (!function (e, t) {
          return e.eventKeyMap.hasOwnProperty(t);
        }(n, e)) return this.logger.log(q.WARNING, z.EVENT_KEY_NOT_FOUND, "OPTIMIZELY", e), void this.logger.log(q.WARNING, z.NOT_TRACKING_USER, "OPTIMIZELY", t);
        var o = function (e) {
          var t = e.configObj,
            r = e.userId,
            i = e.userAttributes,
            n = e.clientEngine,
            o = e.clientVersion,
            s = e.eventKey,
            a = e.eventTags,
            u = Je(t, s),
            l = a ? _r(a, Ur) : null,
            c = a ? vr(a, Ur) : null;
          return {
            type: "conversion",
            timestamp: A.currentTimestamp(),
            uuid: A.uuid(),
            user: {
              id: r,
              attributes: Cr(t, i)
            },
            context: {
              accountId: t.accountId,
              projectId: t.projectId,
              revision: t.revision,
              clientName: n,
              clientVersion: o,
              anonymizeIP: t.anonymizeIP || !1,
              botFiltering: t.botFiltering
            },
            event: {
              id: u,
              key: s
            },
            revenue: l,
            value: c,
            tags: a
          };
        }({
          eventKey: e,
          eventTags: i = this.filterEmptyValues(i),
          userId: t,
          userAttributes: r,
          clientEngine: this.clientEngine,
          clientVersion: this.clientVersion,
          configObj: n
        });
        this.logger.log(q.INFO, z.TRACK_EVENT, "OPTIMIZELY", e, t), this.eventProcessor.process(o), this.emitNotificationCenterTrack(e, t, r, i);
      } catch (e) {
        this.logger.log(q.ERROR, e.message), this.errorHandler.handleError(e), this.logger.log(q.ERROR, z.NOT_TRACKING_USER, "OPTIMIZELY", t);
      }
    }, e.prototype.emitNotificationCenterTrack = function (e, t, r, i) {
      try {
        var n = this.projectConfigManager.getConfig();
        if (!n) return;
        var o = Tr({
          attributes: r,
          clientEngine: this.clientEngine,
          clientVersion: this.clientVersion,
          configObj: n,
          eventKey: e,
          eventTags: i,
          logger: this.logger,
          userId: t
        });
        this.notificationCenter.sendNotifications(w.TRACK, {
          eventKey: e,
          userId: t,
          attributes: r,
          eventTags: i,
          logEvent: o
        });
      } catch (e) {
        this.logger.log(q.ERROR, e.message), this.errorHandler.handleError(e);
      }
    }, e.prototype.getVariation = function (e, t, r) {
      try {
        if (!this.isValidInstance()) return this.logger.log(q.ERROR, z.INVALID_OBJECT, "OPTIMIZELY", "getVariation"), null;
        try {
          if (!this.validateInputs({
            experiment_key: e,
            user_id: t
          }, r)) return null;
          var i = this.projectConfigManager.getConfig();
          if (!i) return null;
          var n = i.experimentKeyMap[e];
          if (!n || n.isRollout) return this.logger.log(q.DEBUG, H.INVALID_EXPERIMENT_KEY, "OPTIMIZELY", e), null;
          var o = this.decisionService.getVariation(i, n, this.createInternalUserContext(t, r)).result,
            s = (a = i, u = n.id, a.experimentFeatureMap.hasOwnProperty(u) ? X.FEATURE_TEST : X.AB_TEST);
          return this.notificationCenter.sendNotifications(w.DECISION, {
            type: s,
            userId: t,
            attributes: r || {},
            decisionInfo: {
              experimentKey: e,
              variationKey: o
            }
          }), o;
        } catch (e) {
          return this.logger.log(q.ERROR, e.message), this.errorHandler.handleError(e), null;
        }
      } catch (e) {
        return this.logger.log(q.ERROR, e.message), this.errorHandler.handleError(e), null;
      }
      var a, u;
    }, e.prototype.setForcedVariation = function (e, t, r) {
      if (!this.validateInputs({
        experiment_key: e,
        user_id: t
      })) return !1;
      var i = this.projectConfigManager.getConfig();
      if (!i) return !1;
      try {
        return this.decisionService.setForcedVariation(i, e, t, r);
      } catch (e) {
        return this.logger.log(q.ERROR, e.message), this.errorHandler.handleError(e), !1;
      }
    }, e.prototype.getForcedVariation = function (e, t) {
      if (!this.validateInputs({
        experiment_key: e,
        user_id: t
      })) return null;
      var r = this.projectConfigManager.getConfig();
      if (!r) return null;
      try {
        return this.decisionService.getForcedVariation(r, e, t).result;
      } catch (e) {
        return this.logger.log(q.ERROR, e.message), this.errorHandler.handleError(e), null;
      }
    }, e.prototype.validateInputs = function (e, t, r) {
      try {
        if (e.hasOwnProperty("user_id")) {
          var i = e.user_id;
          if ("string" != typeof i || null === i || "undefined" === i) throw new Error(N(H.INVALID_INPUT_FORMAT, "OPTIMIZELY", "user_id"));
          delete e.user_id;
        }
        return Object.keys(e).forEach(function (t) {
          if (!Er(e[t])) throw new Error(N(H.INVALID_INPUT_FORMAT, "OPTIMIZELY", t));
        }), t && function (e) {
          if ("object" != typeof e || Array.isArray(e) || null === e) throw new Error(N(H.INVALID_ATTRIBUTES, "ATTRIBUTES_VALIDATOR"));
          Object.keys(e).forEach(function (t) {
            if (void 0 === e[t]) throw new Error(N(H.UNDEFINED_ATTRIBUTE, "ATTRIBUTES_VALIDATOR", t));
          });
        }(t), r && function (e) {
          if ("object" != typeof e || Array.isArray(e) || null === e) throw new Error(N(H.INVALID_EVENT_TAGS, "EVENT_TAGS_VALIDATOR"));
        }(r), !0;
      } catch (e) {
        return this.logger.log(q.ERROR, e.message), this.errorHandler.handleError(e), !1;
      }
    }, e.prototype.notActivatingExperiment = function (e, t) {
      return this.logger.log(q.INFO, z.NOT_ACTIVATING_USER, "OPTIMIZELY", t, e), null;
    }, e.prototype.filterEmptyValues = function (e) {
      for (var t in e) !e.hasOwnProperty(t) || null !== e[t] && void 0 !== e[t] || delete e[t];
      return e;
    }, e.prototype.isFeatureEnabled = function (e, t, r) {
      try {
        if (!this.isValidInstance()) return this.logger.log(q.ERROR, z.INVALID_OBJECT, "OPTIMIZELY", "isFeatureEnabled"), !1;
        if (!this.validateInputs({
          feature_key: e,
          user_id: t
        }, r)) return !1;
        var i = this.projectConfigManager.getConfig();
        if (!i) return !1;
        var n = rt(i, e, this.logger);
        if (!n) return !1;
        var o = {},
          s = this.createInternalUserContext(t, r),
          a = this.decisionService.getVariationForFeature(i, n, s).result,
          u = a.decisionSource,
          l = mr(a),
          c = Ar(a),
          p = Dr(a);
        u === J.FEATURE_TEST && (o = {
          experimentKey: l,
          variationKey: c
        }), (u === J.FEATURE_TEST || u === J.ROLLOUT && ot(i)) && this.sendImpressionEvent(a, n.key, t, p, r), !0 === p ? this.logger.log(q.INFO, z.FEATURE_ENABLED_FOR_USER, "OPTIMIZELY", e, t) : (this.logger.log(q.INFO, z.FEATURE_NOT_ENABLED_FOR_USER, "OPTIMIZELY", e, t), p = !1);
        var d = {
          featureKey: e,
          featureEnabled: p,
          source: a.decisionSource,
          sourceInfo: o
        };
        return this.notificationCenter.sendNotifications(w.DECISION, {
          type: X.FEATURE,
          userId: t,
          attributes: r || {},
          decisionInfo: d
        }), p;
      } catch (e) {
        return this.logger.log(q.ERROR, e.message), this.errorHandler.handleError(e), !1;
      }
    }, e.prototype.getEnabledFeatures = function (e, t) {
      var r = this;
      try {
        var i = [];
        if (!this.isValidInstance()) return this.logger.log(q.ERROR, z.INVALID_OBJECT, "OPTIMIZELY", "getEnabledFeatures"), i;
        if (!this.validateInputs({
          user_id: e
        })) return i;
        var n = this.projectConfigManager.getConfig();
        return n ? (v(n.featureKeyMap).forEach(function (n) {
          r.isFeatureEnabled(n.key, e, t) && i.push(n.key);
        }), i) : i;
      } catch (e) {
        return this.logger.log(q.ERROR, e.message), this.errorHandler.handleError(e), [];
      }
    }, e.prototype.getFeatureVariable = function (e, t, r, i) {
      try {
        return this.isValidInstance() ? this.getFeatureVariableForType(e, t, null, r, i) : (this.logger.log(q.ERROR, z.INVALID_OBJECT, "OPTIMIZELY", "getFeatureVariable"), null);
      } catch (e) {
        return this.logger.log(q.ERROR, e.message), this.errorHandler.handleError(e), null;
      }
    }, e.prototype.getFeatureVariableForType = function (e, t, r, i, n) {
      if (!this.validateInputs({
        feature_key: e,
        variable_key: t,
        user_id: i
      }, n)) return null;
      var o = this.projectConfigManager.getConfig();
      if (!o) return null;
      var s = rt(o, e, this.logger);
      if (!s) return null;
      var a = function (e, t, r, i) {
        var n = e.featureKeyMap[t];
        if (!n) return i.log(q.ERROR, H.FEATURE_NOT_IN_DATAFILE, je, t), null;
        var o = n.variableKeyMap[r];
        return o || (i.log(q.ERROR, H.VARIABLE_KEY_NOT_IN_DATAFILE, je, r, t), null);
      }(o, e, t, this.logger);
      if (!a) return null;
      if (r && a.type !== r) return this.logger.log(q.WARNING, z.VARIABLE_REQUESTED_WITH_WRONG_TYPE, "OPTIMIZELY", r, a.type), null;
      var u = this.createInternalUserContext(i, n),
        l = this.decisionService.getVariationForFeature(o, s, u).result,
        c = Dr(l),
        p = this.getFeatureVariableValueFromVariation(e, c, l.variation, a, i),
        d = {};
      return l.decisionSource === J.FEATURE_TEST && null !== l.experiment && null !== l.variation && (d = {
        experimentKey: l.experiment.key,
        variationKey: l.variation.key
      }), this.notificationCenter.sendNotifications(w.DECISION, {
        type: X.FEATURE_VARIABLE,
        userId: i,
        attributes: n || {},
        decisionInfo: {
          featureKey: e,
          featureEnabled: c,
          source: l.decisionSource,
          variableKey: t,
          variableValue: p,
          variableType: a.type,
          sourceInfo: d
        }
      }), p;
    }, e.prototype.getFeatureVariableValueFromVariation = function (e, t, r, i, n) {
      var o = this.projectConfigManager.getConfig();
      if (!o) return null;
      var s = i.defaultValue;
      if (null !== r) {
        var a = function (e, t, r, i) {
          if (!t || !r) return null;
          if (!e.variationVariableUsageMap.hasOwnProperty(r.id)) return i.log(q.ERROR, H.VARIATION_ID_NOT_IN_DATAFILE_NO_EXPERIMENT, je, r.id), null;
          var n = e.variationVariableUsageMap[r.id][t.id];
          return n ? n.value : null;
        }(o, i, r, this.logger);
        null !== a ? t ? (s = a, this.logger.log(q.INFO, z.USER_RECEIVED_VARIABLE_VALUE, "OPTIMIZELY", s, i.key, e)) : this.logger.log(q.INFO, z.FEATURE_NOT_ENABLED_RETURN_DEFAULT_VARIABLE_VALUE, "OPTIMIZELY", e, n, s) : this.logger.log(q.INFO, z.VARIABLE_NOT_USED_RETURN_DEFAULT_VARIABLE_VALUE, "OPTIMIZELY", i.key, r.key);
      } else this.logger.log(q.INFO, z.USER_RECEIVED_DEFAULT_VARIABLE_VALUE, "OPTIMIZELY", n, i.key, e);
      return function (e, t, r) {
        var i;
        switch (t) {
          case Z.BOOLEAN:
            "true" !== e && "false" !== e ? (r.log(q.ERROR, H.UNABLE_TO_CAST_VALUE, je, e, t), i = null) : i = "true" === e;
            break;
          case Z.INTEGER:
            i = parseInt(e, 10), isNaN(i) && (r.log(q.ERROR, H.UNABLE_TO_CAST_VALUE, je, e, t), i = null);
            break;
          case Z.DOUBLE:
            i = parseFloat(e), isNaN(i) && (r.log(q.ERROR, H.UNABLE_TO_CAST_VALUE, je, e, t), i = null);
            break;
          case Z.JSON:
            try {
              i = JSON.parse(e);
            } catch (n) {
              r.log(q.ERROR, H.UNABLE_TO_CAST_VALUE, je, e, t), i = null;
            }
            break;
          default:
            i = e;
        }
        return i;
      }(s, i.type, this.logger);
    }, e.prototype.getFeatureVariableBoolean = function (e, t, r, i) {
      try {
        return this.isValidInstance() ? this.getFeatureVariableForType(e, t, Z.BOOLEAN, r, i) : (this.logger.log(q.ERROR, z.INVALID_OBJECT, "OPTIMIZELY", "getFeatureVariableBoolean"), null);
      } catch (e) {
        return this.logger.log(q.ERROR, e.message), this.errorHandler.handleError(e), null;
      }
    }, e.prototype.getFeatureVariableDouble = function (e, t, r, i) {
      try {
        return this.isValidInstance() ? this.getFeatureVariableForType(e, t, Z.DOUBLE, r, i) : (this.logger.log(q.ERROR, z.INVALID_OBJECT, "OPTIMIZELY", "getFeatureVariableDouble"), null);
      } catch (e) {
        return this.logger.log(q.ERROR, e.message), this.errorHandler.handleError(e), null;
      }
    }, e.prototype.getFeatureVariableInteger = function (e, t, r, i) {
      try {
        return this.isValidInstance() ? this.getFeatureVariableForType(e, t, Z.INTEGER, r, i) : (this.logger.log(q.ERROR, z.INVALID_OBJECT, "OPTIMIZELY", "getFeatureVariableInteger"), null);
      } catch (e) {
        return this.logger.log(q.ERROR, e.message), this.errorHandler.handleError(e), null;
      }
    }, e.prototype.getFeatureVariableString = function (e, t, r, i) {
      try {
        return this.isValidInstance() ? this.getFeatureVariableForType(e, t, Z.STRING, r, i) : (this.logger.log(q.ERROR, z.INVALID_OBJECT, "OPTIMIZELY", "getFeatureVariableString"), null);
      } catch (e) {
        return this.logger.log(q.ERROR, e.message), this.errorHandler.handleError(e), null;
      }
    }, e.prototype.getFeatureVariableJSON = function (e, t, r, i) {
      try {
        return this.isValidInstance() ? this.getFeatureVariableForType(e, t, Z.JSON, r, i) : (this.logger.log(q.ERROR, z.INVALID_OBJECT, "OPTIMIZELY", "getFeatureVariableJSON"), null);
      } catch (e) {
        return this.logger.log(q.ERROR, e.message), this.errorHandler.handleError(e), null;
      }
    }, e.prototype.getAllFeatureVariables = function (e, t, r) {
      var i = this;
      try {
        if (!this.isValidInstance()) return this.logger.log(q.ERROR, z.INVALID_OBJECT, "OPTIMIZELY", "getAllFeatureVariables"), null;
        if (!this.validateInputs({
          feature_key: e,
          user_id: t
        }, r)) return null;
        var n = this.projectConfigManager.getConfig();
        if (!n) return null;
        var o = rt(n, e, this.logger);
        if (!o) return null;
        var s = this.createInternalUserContext(t, r),
          a = this.decisionService.getVariationForFeature(n, o, s).result,
          u = Dr(a),
          l = {};
        o.variables.forEach(function (r) {
          l[r.key] = i.getFeatureVariableValueFromVariation(e, u, a.variation, r, t);
        });
        var c = {};
        return a.decisionSource === J.FEATURE_TEST && null !== a.experiment && null !== a.variation && (c = {
          experimentKey: a.experiment.key,
          variationKey: a.variation.key
        }), this.notificationCenter.sendNotifications(w.DECISION, {
          type: X.ALL_FEATURE_VARIABLES,
          userId: t,
          attributes: r || {},
          decisionInfo: {
            featureKey: e,
            featureEnabled: u,
            source: a.decisionSource,
            variableValues: l,
            sourceInfo: c
          }
        }), l;
      } catch (e) {
        return this.logger.log(q.ERROR, e.message), this.errorHandler.handleError(e), null;
      }
    }, e.prototype.getOptimizelyConfig = function () {
      try {
        return this.projectConfigManager.getConfig() ? this.projectConfigManager.getOptimizelyConfig() : null;
      } catch (e) {
        return this.logger.log(q.ERROR, e.message), this.errorHandler.handleError(e), null;
      }
    }, e.prototype.close = function () {
      var e,
        t = this;
      try {
        this.odpManager && this.odpManager.stop(), this.notificationCenter.clearAllNotificationListeners();
        var r = null === (e = this.projectConfigManager.getConfig()) || void 0 === e ? void 0 : e.sdkKey;
        r && xe.removeNotificationCenter(r);
        var i = this.eventProcessor.stop();
        return this.disposeOnUpdate && (this.disposeOnUpdate(), this.disposeOnUpdate = null), this.projectConfigManager && this.projectConfigManager.stop(), Object.keys(this.readyTimeouts).forEach(function (e) {
          var r = t.readyTimeouts[e];
          clearTimeout(r.readyTimeout), r.onClose();
        }), this.readyTimeouts = {}, i.then(function () {
          return {
            success: !0
          };
        }, function (e) {
          return {
            success: !1,
            reason: String(e)
          };
        });
      } catch (e) {
        return this.logger.log(q.ERROR, e.message), this.errorHandler.handleError(e), Promise.resolve({
          success: !1,
          reason: String(e)
        });
      }
    }, e.prototype.onReady = function (e) {
      var t,
        r,
        i = this;
      "object" == typeof e && null !== e && void 0 !== e.timeout && (t = e.timeout), A.isSafeInteger(t) || (t = 3e4);
      var n = new Promise(function (e) {
          r = e;
        }),
        o = this.nextReadyTimeoutId;
      this.nextReadyTimeoutId++;
      var s = setTimeout(function () {
        delete i.readyTimeouts[o], r({
          success: !1,
          reason: N("onReady timeout expired after %s ms", t)
        });
      }, t);
      return this.readyTimeouts[o] = {
        readyTimeout: s,
        onClose: function onClose() {
          r({
            success: !1,
            reason: "Instance closed"
          });
        }
      }, this.readyPromise.then(function () {
        clearTimeout(s), delete i.readyTimeouts[o], r({
          success: !0
        });
      }), Promise.race([this.readyPromise, n]);
    }, e.prototype.createUserContext = function (e, t) {
      var r,
        i = null != e ? e : null === (r = this.odpManager) || void 0 === r ? void 0 : r.getVuid();
      return void 0 !== i && this.validateInputs({
        user_id: i
      }, t) ? new Ft({
        optimizely: this,
        userId: i,
        attributes: t,
        shouldIdentifyUser: !0
      }) : null;
    }, e.prototype.createInternalUserContext = function (e, t) {
      return new Ft({
        optimizely: this,
        userId: e,
        attributes: t,
        shouldIdentifyUser: !1
      });
    }, e.prototype.decide = function (e, t, r) {
      var i,
        n,
        o,
        s,
        a = this;
      void 0 === r && (r = []);
      var u,
        l = e.getUserId(),
        p = e.getAttributes(),
        d = this.projectConfigManager.getConfig(),
        f = [];
      if (!this.isValidInstance() || !d) return this.logger.log(q.INFO, z.INVALID_OBJECT, "OPTIMIZELY", "decide"), Mt(t, e, [$.SDK_NOT_READY]);
      var g = d.featureKeyMap[t];
      if (!g) return this.logger.log(q.ERROR, H.FEATURE_NOT_IN_DATAFILE, "OPTIMIZELY", t), Mt(t, e, [N($.FLAG_KEY_INVALID, t)]);
      var E = this.getAllDecideOptions(r),
        h = this.decisionService.findValidatedForcedDecision(d, e, t);
      f.push.apply(f, h.reasons);
      var I = h.result;
      if (I) u = {
        experiment: null,
        variation: I,
        decisionSource: J.FEATURE_TEST
      };else {
        var _ = this.decisionService.getVariationForFeature(d, g, e, E);
        f.push.apply(f, _.reasons), u = _.result;
      }
      var v = u.decisionSource,
        y = null !== (n = null === (i = u.experiment) || void 0 === i ? void 0 : i.key) && void 0 !== n ? n : null,
        O = null !== (s = null === (o = u.variation) || void 0 === o ? void 0 : o.key) && void 0 !== s ? s : null,
        R = Dr(u);
      !0 === R ? this.logger.log(q.INFO, z.FEATURE_ENABLED_FOR_USER, "OPTIMIZELY", t, l) : this.logger.log(q.INFO, z.FEATURE_NOT_ENABLED_FOR_USER, "OPTIMIZELY", t, l);
      var T = {},
        m = !1;
      E[exports.OptimizelyDecideOption.EXCLUDE_VARIABLES] || g.variables.forEach(function (e) {
        T[e.key] = a.getFeatureVariableValueFromVariation(t, R, u.variation, e, l);
      }), !E[exports.OptimizelyDecideOption.DISABLE_DECISION_EVENT] && (v === J.FEATURE_TEST || v === J.ROLLOUT && ot(d)) && (this.sendImpressionEvent(u, t, l, R, p), m = !0);
      var A = [];
      E[exports.OptimizelyDecideOption.INCLUDE_REASONS] && (A = f.map(function (e) {
        return N.apply(void 0, c([e[0]], e.slice(1), !1));
      }));
      var D = {
        flagKey: t,
        enabled: R,
        variationKey: O,
        ruleKey: y,
        variables: T,
        reasons: A,
        decisionEventDispatched: m
      };
      return this.notificationCenter.sendNotifications(w.DECISION, {
        type: X.FLAG,
        userId: l,
        attributes: p,
        decisionInfo: D
      }), {
        variationKey: O,
        enabled: R,
        variables: T,
        ruleKey: y,
        flagKey: t,
        userContext: e,
        reasons: A
      };
    }, e.prototype.getAllDecideOptions = function (e) {
      var t = this,
        r = _a({}, this.defaultDecideOptions);
      return Array.isArray(e) ? e.forEach(function (e) {
        exports.OptimizelyDecideOption[e] ? r[e] = !0 : t.logger.log(q.WARNING, z.UNRECOGNIZED_DECIDE_OPTION, "OPTIMIZELY", e);
      }) : this.logger.log(q.DEBUG, z.INVALID_DECIDE_OPTIONS, "OPTIMIZELY"), r;
    }, e.prototype.decideForKeys = function (e, t, r) {
      var i = this;
      void 0 === r && (r = []);
      var n = {};
      if (!this.isValidInstance()) return this.logger.log(q.ERROR, z.INVALID_OBJECT, "OPTIMIZELY", "decideForKeys"), n;
      if (0 === t.length) return n;
      var o = this.getAllDecideOptions(r);
      return t.forEach(function (t) {
        var s = i.decide(e, t, r);
        o[exports.OptimizelyDecideOption.ENABLED_FLAGS_ONLY] && !s.enabled || (n[t] = s);
      }), n;
    }, e.prototype.decideAll = function (e, t) {
      void 0 === t && (t = []);
      var r = this.projectConfigManager.getConfig();
      if (!this.isValidInstance() || !r) return this.logger.log(q.ERROR, z.INVALID_OBJECT, "OPTIMIZELY", "decideAll"), {};
      var i = Object.keys(r.featureKeyMap);
      return this.decideForKeys(e, i, t);
    }, e.prototype.updateOdpSettings = function () {
      var e = this.projectConfigManager.getConfig();
      e && this.odpManager && this.odpManager.updateSettings(e.odpIntegrationConfig);
    }, e.prototype.sendOdpEvent = function (e, t, r, i) {
      if (this.odpManager) {
        var n = null != t ? t : "fullstack",
          o = new Map(r);
        if (r && r.size > 0) try {
          r.forEach(function (e, t) {
            "fs-user-id" !== t.toLowerCase() && ee.FS_USER_ID !== t.toLowerCase() || (o.delete(t), o.set(ee.FS_USER_ID, e));
          });
        } catch (e) {
          this.logger.warn(z.ODP_SEND_EVENT_IDENTIFIER_CONVERSION_FAILED);
        }
        try {
          var s = new yt(n, e, o, i);
          this.odpManager.sendEvent(s);
        } catch (e) {
          this.logger.error(H.ODP_EVENT_FAILED, e);
        }
      } else this.logger.error(H.ODP_EVENT_FAILED_ODP_MANAGER_MISSING);
    }, e.prototype.isOdpIntegrated = function () {
      var e, t, r;
      return null !== (r = null === (t = null === (e = this.projectConfigManager.getConfig()) || void 0 === e ? void 0 : e.odpIntegrationConfig) || void 0 === t ? void 0 : t.integrated) && void 0 !== r && r;
    }, e.prototype.identifyUser = function (e) {
      this.odpManager && this.isOdpIntegrated() && this.odpManager.identifyUser(e);
    }, e.prototype.fetchQualifiedSegments = function (e, t) {
      return u(this, void 0, void 0, function () {
        return l(this, function (r) {
          switch (r.label) {
            case 0:
              return this.odpManager ? [4, this.odpManager.fetchQualifiedSegments(e, t)] : [2, null];
            case 1:
              return [2, r.sent()];
          }
        });
      });
    }, e.prototype.getVuid = function () {
      var e;
      if (this.odpManager) {
        if (this.odpManager.isVuidEnabled()) return this.odpManager.getVuid();
        this.logger.log(q.WARNING, "getVuid() unavailable for this platform", "OPTIMIZELY");
      } else null === (e = this.logger) || void 0 === e || e.error("Unable to get VUID - ODP Manager is not instantiated yet.");
    }, e;
  }(),
  Vr = {
    parseUserAgentInfo: function parseUserAgentInfo() {
      var e = new n.UAParser().getResult();
      return {
        os: e.os,
        device: e.device
      };
    }
  };
function Mr() {
  return Vr;
}
var Fr = Object.freeze({
    __proto__: null,
    get LogLevel() {
      return exports.LogLevel;
    },
    getLogger: M,
    setLogHandler: F,
    LOG_LEVEL: q,
    createLogger: Oe
  }),
  xr = M();
x.setLogHandler(Oe()), x.setLogLevel(exports.LogLevel.INFO);
var kr = !1,
  wr = function wr(e) {
    var t, r;
    try {
      var i = !1;
      e.errorHandler && (r = e.errorHandler, p = r), e.logger && (x.setLogHandler(e.logger), x.setLogLevel(exports.LogLevel.NOTSET)), void 0 !== e.logLevel && x.setLogLevel(e.logLevel);
      try {
        ge(e), i = !0;
      } catch (e) {
        xr.error(e);
      }
      var n = void 0;
      null == e.eventDispatcher ? (n = new ae({
        eventDispatcher: _e
      }), kr || (n.sendPendingEvents(), kr = !0)) : n = e.eventDispatcher;
      var o = e.closingEventDispatcher;
      !e.eventDispatcher && !o && window.navigator && "sendBeacon" in window.navigator && (o = ve);
      var s = e.eventBatchSize,
        u = e.eventFlushInterval;
      Ne(e.eventBatchSize) || (xr.warn("Invalid eventBatchSize %s, defaulting to %s", e.eventBatchSize, 10), s = 10), Te(e.eventFlushInterval) || (xr.warn("Invalid eventFlushInterval %s, defaulting to %s", e.eventFlushInterval, 1e3), u = 1e3);
      var l = d(),
        c = Ae({
          logger: xr,
          errorHandler: l
        }),
        f = {
          dispatcher: n,
          closingDispatcher: o,
          flushInterval: u,
          batchSize: s,
          maxQueueSize: e.eventMaxQueueSize || 1e4,
          notificationCenter: c
        },
        g = !0 === (null === (t = e.odpOptions) || void 0 === t ? void 0 : t.disabled);
      g && xr.info(z.ODP_DISABLED);
      var E = e.clientEngine,
        h = e.clientVersion,
        I = _a(_a({
          clientEngine: "javascript-sdk"
        }, e), {
          eventProcessor: Ue.createEventProcessor(f),
          logger: xr,
          errorHandler: l,
          datafileManager: e.sdkKey ? st(e.sdkKey, xr, e.datafile, e.datafileOptions) : void 0,
          notificationCenter: c,
          isValidInstance: i,
          odpManager: g ? void 0 : Vt.createInstance({
            logger: xr,
            odpOptions: e.odpOptions,
            clientEngine: E,
            clientVersion: h
          })
        }),
        _ = new br(I);
      try {
        if ("function" == typeof window.addEventListener) {
          var v = "onpagehide" in window ? "pagehide" : "unload";
          window.addEventListener(v, function () {
            _.close();
          }, !1);
        }
      } catch (e) {
        xr.error(z.UNABLE_TO_ATTACH_UNLOAD, "INDEX_BROWSER", e.message);
      }
      return _;
    } catch (e) {
      return xr.error(e), null;
    }
  },
  Gr = function Gr() {
    kr = !1;
  },
  Br = x.setLogHandler,
  Kr = x.setLogLevel,
  jr = _a(_a({}, Fr), {
    logging: Re,
    errorHandler: he,
    eventDispatcher: _e,
    sendBeaconEventDispatcher: ve,
    enums: re,
    setLogger: Br,
    setLogLevel: Kr,
    createInstance: wr,
    __internalResetRetryState: Gr,
    OptimizelyDecideOption: exports.OptimizelyDecideOption,
    getUserAgentParser: Mr
  });
exports.LOG_LEVEL = q, exports.__internalResetRetryState = Gr, exports.createInstance = wr, exports.createLogger = Oe, exports.default = jr, exports.enums = re, exports.errorHandler = he, exports.eventDispatcher = _e, exports.getLogger = M, exports.getUserAgentParser = Mr, exports.logging = Re, exports.sendBeaconEventDispatcher = ve, exports.setLogHandler = F, exports.setLogLevel = Kr, exports.setLogger = Br;